// #AFF205
import { Alert } from '@/Interface/alert';
import { EnvBanifits } from '@/Interface/envirmentBanifits';
import { HistoryDetail } from '@/Interface/history';
import { PlantDetail } from '@/Interface/plantDetail';
import { PlantList, PlantPower, HeatMapIntterface } from '@/Interface/power';
import { TodayWeather } from '@/Interface/weather';
import { formatDate, formatNumber } from '@angular/common';
import { Component, ElementRef, EventEmitter, OnInit, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { UtilityService } from '@services/utility.service';
import * as Highcharts from 'highcharts';
import { SlickCarouselComponent } from 'ngx-slick-carousel';
import { AlarmStatusInterface } from '@/Interface/plants';
import { ChangeDetectorRef } from '@angular/core';
import { BaseChartDirective } from 'ng2-charts';
import {
    NgbDateStruct,
} from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { InverterDetail } from '@/Interface/inverterDetail';
import { Pv, Voltage } from '@/Interface/pv';
import { DatePipe } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
import { PredictedRoiService } from '@services/prediction/predicted-roi.service';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker';
import { DEFAULT_PERMISSIONS } from '@/constants/constants';
import { PermissionsService } from '@services/permissions.service';
import { ActivatedRoute, Router } from '@angular/router';

export const rotateAnimation = (duration: string = '0.5s') =>
    trigger('rotateAnimation', [
        state('default', style({ transform: 'rotate(0deg)' })),
        state('reloading', style({ transform: 'rotate(0deg)' })), // Prevent reverse rotation
        transition('default => reloading', animate(`${duration} ease-in-out`, style({ transform: 'rotate(360deg)' }))),
    ]);

@Component({
    selector: 'app-plant-detail',
    templateUrl: './plant-detail.component.html',
    styleUrls: ['./plant-detail.component.scss'],
    animations: [rotateAnimation('0.5s')],
})
export class PlantDetailComponent implements OnInit {
    @ViewChild('inputValue') input: ElementRef;
    selectedPlantName: string;
    selectedNumber: number;
    loader: boolean;
    dayWisePG: boolean = true;
    monthWisePG: boolean = false;
    yearWisePG: boolean = false;
    lifetTimeWisePG: boolean = false;
    lineChartcollectTime: any[] = [];
    emiPraghcollectTime: any[] = [];
    emiPraghRadiant: any[] = [];
    lineChartcollectcollect: any[] = [];
    currentIndex: number = 0;
    predictedPaybackClicked: boolean = false
    chartUpdateFlag: boolean = false

    alarmSts: AlarmStatusInterface = new AlarmStatusInterface();
    // Keyed by alarm type so the donut always matches the legend icons
    alarmChartColors = [
        { name: 'Critical', value: '#D64550' },
        { name: 'Major', value: '#F28C38' },
        { name: 'Minor', value: '#F2C14E' },
        { name: 'Warning', value: '#2FA6A0' },
    ];
    alarmChartScheme: any = { domain: ['#D64550', '#F28C38', '#F2C14E', '#2FA6A0'] };

    lineChartcollectConsumption: any[] = [];
    lineChartcollectMainsPower: any[] = [];

    totalhistory: any[] = [];
    monthCartListInfo: any[] = [];
    monthCartListInfoPower: any[] = [];
    monthCartListInfoPowerConsumed: any = [];
    originalCost: number

    showhistory: boolean = false;
    gethistory: HistoryDetail;
    getPowerList: PlantList;
    PlantPowerDetails: PlantPower;
    heatMapList: HeatMapIntterface;
    Highcharts: typeof Highcharts = Highcharts;
    blockinfo: any[] = [];
    ppf: boolean = true;
    invert: boolean = false;
    pv: boolean = false;
    roi: boolean = false;
    eme: boolean = false;
    wapda: boolean = false;
    devices: boolean = false;
    alarms: boolean = false;
    model: NgbDateStruct;
    date: { year: number; month: number };
    activeTab: boolean;
    inverterDetail: InverterDetail[];
    pvList: Pv[] = [];
    voltage = new Voltage();
    ShowPowerGuage: boolean = false;
    selectedDate = '';
    selectedYear = '';
    selectedMonth = '';
    selectedDay = '';
    yearOptions: any[] = [];
    roiChart: any
    predictionParameterForm: FormGroup;
    actualCategories = []
    allCategories = []
    legends: any = [
        { name: 'Power Generated', color: '#d7df27' },
        { name: 'Power Consumed', color: '#EF4323' }
    ];
    isReloadingBtn: boolean = false;
    permissions = { ...DEFAULT_PERMISSIONS };
    permissionsReady: boolean = false;
    //loading:boolean =false;

    public reloadPlantDetails() {
        this.isReloadingBtn = true
        this.getWeatherUpdates();
        this.getPlantDetailList();
        this.envirmentBanifit();
        this.getpowerFlow();
        this.showAlert();
        this.selectInverterDetail();
        this.pvDataList();
        this.getAlarmStatus(this.getStationCode);
        this.geHeatMapData();
        // this.fiveMinData();
        this.EmiGraph(this.dtEnv);
        setTimeout(() => {
            this.isReloadingBtn = false;
        }, 500);
    }

    EmiChartGraph: Highcharts.Options = {
        chart: { backgroundColor: 'transparent' },   // ADD
        title: {
            text: 'EMI Graph',

            style: {
                color: 'black',
                align: 'left'
            }
        },

        xAxis: {
            categories: this.emiPraghcollectTime,
            title: {
                text: '<b >Time</b>'
            }
        },
        yAxis: {
            min: null,
            title: {
                text: '<b >Irradiance</b>',
                align: 'middle'
            },
            labels: {
                overflow: 'justify'
            }
        },
        plotOptions: {
            pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                dataLabels: {
                    enabled: false
                },
                showInLegend: true
            }
        },

        series: [
            {
                data: this.emiPraghRadiant,
                type: 'area'
            }
            // {
            //     data: this.lineChartcollectcollect,
            //     type: 'area'
            // }
        ]
    };

    blockOption: Highcharts.Options = {
        chart: { backgroundColor: 'transparent' },   // ADD
        title: {
            text: 'Block Wise Data',

            style: {
                color: 'black',
                align: 'left'
            }
        },
        plotOptions: {
            pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                dataLabels: {
                    enabled: false
                },
                showInLegend: true
            }
        },

        series: [
            {
                data: this.lineChartcollectTime,
                type: 'area'
            },
            {
                data: this.lineChartcollectcollect,
                type: 'area'
            }
        ]
    };

    barChart: Highcharts.Options = {
        chart: { backgroundColor: 'transparent' },   // ADD
        title: {
            text: ' ',

            style: {
                color: 'black',
                align: 'left'
            }
        },
        plotOptions: {
            pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                dataLabels: {
                    enabled: true
                },
                showInLegend: true
            }
        },

        series: [
            {
                data: this.monthCartListInfo,
                type: 'column'
            },
            {
                data: this.monthCartListInfoPower,
                type: 'column'
            }
        ]
    };
    // multi line pv chat variables 
    pvVoltages: string[] = [];
    pvCurrents: string[] = [];
    pvEnergy: string[] = [];
    pvPowers: string[] = [];
    pvTemperature: string[] = [];
    pvPercentage: string[] = [];
    pvFrequency: string[] = [];
    // new pv graph
    selectedVoltages: string[] = [];
    selectedCurrents: string[] = [];
    selectedEnergy: string[] = [];
    selectedPowers: string[] = [];
    selectedTemperature: string[] = [];
    selectedPercentage: string[] = [];
    selectedFrequency: string[] = [];

    private colorObj: { [key: string]: string } = {
        current: '#F2C14E',
        frequency: '#02D3C8',
        power: '#414141',
        temperature: '#FF7800',
        voltage: '#EF4323',
        energy: '#23B762',
        percentage: '#0E9CFF',
    };
    public selectedPVDate: Date = new Date();
    datePickerConfig: Partial<BsDaterangepickerConfig> = {
        showWeekNumbers: false,
        adaptivePosition: true,
    };
    public pvMultilineChartOptions!: Highcharts.Options;
    // @ViewChild('pvMultiChart') pvMultiChart: any;
    @ViewChildren('pvMultiChart') pvMultiCharts: QueryList<any>;
    private pvCharts: Highcharts.Chart[] = [];
    currentSlide = 0
    updateFlag = false; // Add this property for change detection
    // pvMultilineChartOptions: Highcharts.Options = {
    //     chart: {
    //         zooming: { type: 'xy' },
    //         backgroundColor: 'transparent',
    //         height: 400, // Ensure enough space for chart + legend
    //         marginBottom: 80 // Reserve space for the legend & credits
    //     },
    //     title: { text: '' },
    //     xAxis: [{
    //         categories: [
    //             "12:00 AM",
    //             "12:05 AM",
    //             "12:10 AM",
    //             "12:15 AM",
    //             "12:20 AM",
    //             "12:25 AM",
    //             "12:30 AM",
    //             "12:35 AM",
    //             "12:40 AM",
    //             "12:45 AM",
    //             "12:50 AM",
    //             "12:55 AM",
    //             "01:00 AM",
    //             "01:05 AM",
    //             "01:10 AM",
    //             "01:15 AM",
    //             "01:20 AM",
    //             "01:25 AM",
    //             "01:30 AM",
    //             "01:35 AM",
    //             "01:40 AM",
    //             "01:45 AM",
    //             "01:50 AM",
    //             "01:55 AM",
    //             "02:00 AM",
    //             "02:05 AM",
    //             "02:10 AM",
    //             "02:15 AM",
    //             "02:20 AM",
    //             "02:25 AM",
    //             "02:30 AM",
    //             "02:35 AM",
    //             "02:40 AM",
    //             "02:45 AM",
    //             "02:50 AM",
    //             "02:55 AM",
    //             "03:00 AM",
    //             "03:05 AM",
    //             "03:10 AM",
    //             "03:15 AM",
    //             "03:20 AM",
    //             "03:25 AM",
    //             "03:30 AM",
    //             "03:35 AM",
    //             "03:40 AM",
    //             "03:45 AM",
    //             "03:50 AM",
    //             "03:55 AM",
    //             "04:00 AM",
    //             "04:05 AM",
    //             "04:10 AM",
    //             "04:15 AM",
    //             "04:20 AM",
    //             "04:25 AM",
    //             "04:30 AM",
    //             "04:35 AM",
    //             "04:40 AM",
    //             "04:45 AM",
    //             "04:50 AM",
    //             "04:55 AM",
    //             "05:00 AM",
    //             "05:05 AM",
    //             "05:10 AM",
    //             "05:15 AM",
    //             "05:20 AM",
    //             "05:25 AM",
    //             "05:30 AM",
    //             "05:35 AM",
    //             "05:40 AM",
    //             "05:45 AM",
    //             "05:50 AM",
    //             "05:55 AM",
    //             "06:00 AM",
    //             "06:05 AM",
    //             "06:10 AM",
    //             "06:15 AM",
    //             "06:20 AM",
    //             "06:25 AM",
    //             "06:30 AM",
    //             "06:35 AM",
    //             "06:40 AM",
    //             "06:45 AM",
    //             "06:50 AM",
    //             "06:55 AM",
    //             "07:00 AM",
    //             "07:05 AM",
    //             "07:10 AM",
    //             "07:15 AM",
    //             "07:20 AM",
    //             "07:25 AM",
    //             "07:30 AM",
    //             "07:35 AM",
    //             "07:40 AM",
    //             "07:45 AM",
    //             "07:50 AM",
    //             "07:55 AM",
    //             "08:00 AM",
    //             "08:05 AM",
    //             "08:10 AM",
    //             "08:15 AM",
    //             "08:20 AM",
    //             "08:25 AM",
    //             "08:30 AM",
    //             "08:35 AM",
    //             "08:40 AM",
    //             "08:45 AM",
    //             "08:50 AM",
    //             "08:55 AM",
    //             "09:00 AM",
    //             "09:05 AM",
    //             "09:10 AM",
    //             "09:15 AM",
    //             "09:20 AM",
    //             "09:25 AM",
    //             "09:30 AM",
    //             "09:35 AM",
    //             "09:40 AM",
    //             "09:45 AM",
    //             "09:50 AM",
    //             "09:55 AM",
    //             "10:00 AM",
    //             "10:05 AM",
    //             "10:10 AM",
    //             "10:15 AM",
    //             "10:20 AM",
    //             "10:25 AM",
    //             "10:30 AM",
    //             "10:35 AM",
    //             "10:40 AM",
    //             "10:45 AM",
    //             "10:50 AM",
    //             "10:55 AM",
    //             "11:00 AM",
    //             "11:05 AM",
    //             "11:10 AM",
    //             "11:15 AM",
    //             "11:20 AM",
    //             "11:25 AM",
    //             "11:30 AM",
    //             "11:35 AM",
    //             "11:40 AM",
    //             "11:45 AM",
    //             "11:50 AM",
    //             "11:55 AM",
    //             "12:00 PM",
    //             "12:05 PM",
    //             "12:10 PM",
    //             "12:15 PM",
    //             "12:20 PM",
    //             "12:25 PM",
    //             "12:30 PM",
    //             "12:35 PM",
    //             "12:40 PM",
    //             "12:45 PM",
    //             "12:50 PM",
    //             "12:55 PM",
    //             "01:00 PM",
    //             "01:05 PM",
    //             "01:10 PM",
    //             "01:15 PM",
    //             "01:20 PM",
    //             "01:25 PM",
    //             "01:30 PM",
    //             "01:35 PM",
    //             "01:40 PM",
    //             "01:45 PM",
    //             "01:50 PM",
    //             "01:55 PM",
    //             "02:00 PM",
    //             "02:05 PM",
    //             "02:10 PM",
    //             "02:15 PM",
    //             "02:20 PM",
    //             "02:25 PM",
    //             "02:30 PM",
    //             "02:35 PM",
    //             "02:40 PM",
    //             "02:45 PM",
    //             "02:50 PM",
    //             "02:55 PM",
    //             "03:00 PM",
    //             "03:05 PM",
    //             "03:10 PM",
    //             "03:15 PM",
    //             "03:20 PM",
    //             "03:25 PM",
    //             "03:30 PM",
    //             "03:35 PM",
    //             "03:40 PM",
    //             "03:45 PM",
    //             "03:50 PM",
    //             "03:55 PM",
    //             "04:00 PM",
    //             "04:05 PM",
    //             "04:10 PM",
    //             "04:15 PM",
    //             "04:20 PM",
    //             "04:25 PM",
    //             "04:30 PM",
    //             "04:35 PM",
    //             "04:40 PM",
    //             "04:45 PM",
    //             "04:50 PM",
    //             "04:55 PM",
    //             "05:00 PM",
    //             "05:05 PM",
    //             "05:10 PM",
    //             "05:15 PM",
    //             "05:20 PM",
    //             "05:25 PM",
    //             "05:30 PM",
    //             "05:35 PM",
    //             "05:40 PM",
    //             "05:45 PM",
    //             "05:50 PM",
    //             "05:55 PM",
    //             "06:00 PM",
    //             "06:05 PM",
    //             "06:10 PM",
    //             "06:15 PM",
    //             "06:20 PM",
    //             "06:25 PM",
    //             "06:30 PM",
    //             "06:35 PM",
    //             "06:40 PM",
    //             "06:45 PM",
    //             "06:50 PM",
    //             "06:55 PM",
    //             "07:00 PM",
    //             "07:05 PM",
    //             "07:10 PM",
    //             "07:15 PM",
    //             "07:20 PM",
    //             "07:25 PM",
    //             "07:30 PM",
    //             "07:35 PM",
    //             "07:40 PM",
    //             "07:45 PM",
    //             "07:50 PM",
    //             "07:55 PM",
    //             "08:00 PM",
    //             "08:05 PM",
    //             "08:10 PM",
    //             "08:15 PM",
    //             "08:20 PM",
    //             "08:25 PM",
    //             "08:30 PM",
    //             "08:35 PM",
    //             "08:40 PM",
    //             "08:45 PM",
    //             "08:50 PM",
    //             "08:55 PM",
    //             "09:00 PM",
    //             "09:05 PM",
    //             "09:10 PM",
    //             "09:15 PM",
    //             "09:20 PM",
    //             "09:25 PM",
    //             "09:30 PM",
    //             "09:35 PM",
    //             "09:40 PM",
    //             "09:45 PM",
    //             "09:50 PM",
    //             "09:55 PM",
    //             "10:00 PM",
    //             "10:05 PM",
    //             "10:10 PM",
    //             "10:15 PM",
    //             "10:20 PM",
    //             "10:25 PM",
    //             "10:30 PM",
    //             "10:35 PM",
    //             "10:40 PM",
    //             "10:45 PM",
    //             "10:50 PM",
    //             "10:55 PM",
    //             "11:00 PM",
    //             "11:05 PM",
    //             "11:10 PM",
    //             "11:15 PM",
    //             "11:20 PM",
    //             "11:25 PM",
    //             "11:30 PM",
    //             "11:35 PM",
    //             "11:40 PM",
    //             "11:45 PM",
    //             "11:50 PM",
    //             "11:55 PM",
    //             "12:00 AM"
    //         ],
    //         crosshair: true
    //     }],
    //     yAxis: [
    //         {
    //             gridLineWidth: 1,
    //             // min: 0,
    //             title: {
    //                 text: 'Energy',
    //                 style: { color: Highcharts.getOptions().colors?.[1] as string }
    //             },
    //             labels: {
    //                 format: '{value}J',
    //                 style: { color: Highcharts.getOptions().colors?.[1] as string }
    //             },
    //             opposite: false
    //         }
    //     ],
    //     tooltip: { shared: true },
    //     legend: {
    //         layout: 'horizontal',
    //         align: 'center',
    //         verticalAlign: 'bottom',
    //         y: 40,
    //         symbolRadius: 16,  // Makes it circular
    //         symbolWidth: 16,
    //         symbolHeight: 16,
    //     },

    //     plotOptions: {
    //         series: {
    //             connectNulls: true,
    //             marker: {
    //                 enabled: false, // Show marker in legend
    //                 symbol: 'circle' // Ensure the marker is circular
    //             }
    //         }
    //     },
    //     credits: {
    //         enabled: false,
    //     },
    //     series: [
    //         {
    //             name: "Mppt_5_cap",
    //             type: "line",
    //             yAxis: 0,
    //             data: [
    //                 0,
    //                 0,
    //                 1,
    //                 2255,
    //                 0,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 5555,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 1,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 25,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null,
    //                 null
    //             ],
    //             color: "#9C27B0ff",
    //             tooltip: {
    //                 valueSuffix: " J"
    //             },
    //             turboThreshold: 0
    //         }
    //     ],
    //     responsive: {
    //         rules: [{
    //             condition: { maxWidth: 500 },
    //             chartOptions: {
    //                 legend: {
    //                     floating: false,
    //                     layout: 'horizontal',
    //                     align: 'center',
    //                     verticalAlign: 'bottom',
    //                     x: 0,
    //                     y: 0
    //                 },
    //                 yAxis: [
    //                     { labels: { align: 'right', x: 0, y: -6 }, showLastLabel: false },
    //                     { labels: { align: 'left', x: 0, y: -6 }, showLastLabel: false },
    //                     { visible: false }
    //                 ]
    //             }
    //         }]
    //     }
    // };


    // pvMultilineChartOptions: Highcharts.Options = {
    //     chart: {
    //         zooming: { type: 'xy' },
    //         backgroundColor: 'transparent',
    //         height: 400, // Ensure enough space for chart + legend
    //         marginBottom: 80 // Reserve space for the legend & credits
    //     },
    //     title: { text: '' },
    //     xAxis: [{
    //         categories: [
    //             'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    //             'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    //         ],
    //         crosshair: true
    //     }],
    //     yAxis: [
    //         {
    //             labels: {
    //                 format: '{value}°C',
    //                 style: { color: Highcharts.getOptions().colors?.[2] as string }
    //             },
    //             title: {
    //                 text: 'Temperature',
    //                 style: { color: Highcharts.getOptions().colors?.[2] as string }
    //             },
    //             opposite: true
    //         },
    //         {
    //             gridLineWidth: 0,
    //             title: {
    //                 text: 'Rainfall',
    //                 style: { color: Highcharts.getOptions().colors?.[0] as string }
    //             },
    //             labels: {
    //                 format: '{value} mm',
    //                 style: { color: Highcharts.getOptions().colors?.[0] as string }
    //             }
    //         },
    //         {
    //             gridLineWidth: 0,
    //             title: {
    //                 text: 'Sea-Level Pressure',
    //                 style: { color: Highcharts.getOptions().colors?.[1] as string }
    //             },
    //             labels: {
    //                 format: '{value} mb',
    //                 style: { color: Highcharts.getOptions().colors?.[1] as string }
    //             },
    //             opposite: true
    //         }
    //     ],
    //     tooltip: { shared: true },
    //     legend: {
    //         layout: 'horizontal',
    //         align: 'center',
    //         verticalAlign: 'bottom',
    //         y: 40,
    //         symbolRadius: 16,  // Makes it circular
    //         symbolWidth: 16,
    //         symbolHeight: 16,
    //     },

    //     plotOptions: {
    //         series: {
    //             marker: {
    //                 enabled: false, // Show marker in legend
    //                 symbol: 'circle' // Ensure the marker is circular
    //             }
    //         }
    //     },
    //     credits: {
    //         enabled: false,
    //     },
    //     series: [
    //         {
    //             name: 'Rainfall',
    //             type: 'line',
    //             yAxis: 1,
    //             data: [49.9, 71.5, 106.4, 129.2, 144.0, 176.0, 135.6, 148.5, 216.4, 194.1, 95.6, 54.4],
    //             // marker: { enabled: true },
    //             tooltip: { valueSuffix: ' mm' },
    //         },
    //         {
    //             name: 'Sea-Level Pressure',
    //             type: 'line',
    //             yAxis: 2,
    //             data: [1016, 1016, 1015.9, 1015.5, 1012.3, 1009.5, 1009.6, 1010.2, 1013.1, 1016.9, 1018.2, 1016.7],
    //             // marker: { enabled: true },
    //             tooltip: { valueSuffix: ' mb' }
    //         },
    //         {
    //             name: 'Temperature',
    //             type: 'line',
    //             data: [7.0, 6.9, 9.5, 14.5, 18.2, 21.5, 25.2, 26.5, 23.3, 18.3, 13.9, 9.6],
    //             // marker: { enabled: true },
    //             tooltip: { valueSuffix: ' °C' }
    //         }
    //     ],
    //     responsive: {
    //         rules: [{
    //             condition: { maxWidth: 500 },
    //             chartOptions: {
    //                 legend: {
    //                     floating: false,
    //                     layout: 'horizontal',
    //                     align: 'center',
    //                     verticalAlign: 'bottom',
    //                     x: 0,
    //                     y: 0
    //                 },
    //                 yAxis: [
    //                     { labels: { align: 'right', x: 0, y: -6 }, showLastLabel: false },
    //                     { labels: { align: 'left', x: 0, y: -6 }, showLastLabel: false },
    //                     { visible: false }
    //                 ]
    //             }
    //         }]
    //     }
    // };
    // /new pv graph
    powerGauge: any[] = [];
    graphLoader: boolean = false;
    emiGraphLoader: boolean = false;

    labelFormatting(dataPoint) {
        return `${dataPoint.data.name}: ${dataPoint.data.value}%`;
    }

    // onOpenCalendar(container) {
    //     container.monthSelectHandler = (event: any): void => {
    //         container._store.dispatch(container._actions.select(event.date));
    //     };
    //     container.setViewMode('year');
    // }
    onOpenCalendar(container: any) {
        // Set the view to "year" when the calendar opens
        container.setViewMode('year');
        // Override the yearSelectHandler to select the year directly
        container.yearSelectHandler = (event: any): void => {
            const selectedDate = event.date;
            container._store.dispatch(container._actions.select(selectedDate));
            container.hide(); // Close the datepicker after selecting year
        };
    }

    onMonthOpenCalendar(container) {
        container.monthSelectHandler = (event: any): void => {
            container._store.dispatch(container._actions.select(event.date));
        };
        container.setViewMode('month');
    }
    onDayOpenCalendar(container) {
        container.monthSelectHandler = (event: any): void => {
            container._store.dispatch(container._actions.select(event.date));
        };
        container.setViewMode('day');
    }



    pieChartLabel(series: any[], name: string): string {
        const item = series.filter(data => data.name === name);
        if (item.length > 0) {
            return item[0].label;
        }
        return name;
    }
    status: boolean = false;
    dt;
    dtEnv;
    dtEmiEnv;
    irradianceDate: Date = new Date();
    dymont: string = '3';
    evnrBanifits: EnvBanifits;
    plantDetail: PlantDetail;
    countAlert: Alert;
    weather = new TodayWeather();
    // Station codes arrive as strings (list rows, :id route param); the old
    // `number` type never matched the runtime value.
    getStationCode: any = 0;
    showplantGraph: boolean = false;
    getDayRang: number = 3;
    gaugeType = 'semi';
    gaugeValue = 28.3;
    gaugeLabel = 'Total Power';
    installCapacity = 0;
    thick = 11;
    size = 190;
    color = '#3E4A56';
    hight = 160;
    colorgreen: 'green';
    gaugeValueExp = 28.3;
    graphicalView: boolean = false;
    vardata: boolean = true;


    // pvGraphRes : any[] = [ { name: "1", value: 'Volvo', status: 1  },
    //                             { name: "2", value: 'Saab', status: 0 },
    //                             { name: "3", value: 'Opel', status: 1  },
    //                             { name: "4", value: 'Audi', status: 0  }];

    pvGraphRes: any[];
    pvGraphKey: any[];
    isCheckboxDisabled = true;
    selectedCars = [1];
    cars = [
        { id: 1, name: 'Volvo' },
        { id: 2, name: 'Saab', disabled: true },
        { id: 3, name: 'Opel' },
        { id: 4, name: 'Audi' }
    ];
    pvG = [
        { id: 1, name: 'Voltage' },
        { id: 2, name: 'Current' },
        { id: 3, name: 'Power' },

    ];
    inverterGV = [
        { id: 1, name: 'Input DC Graph' },
        { id: 2, name: 'Output Power' },
        { id: 3, name: 'Normalize Power' },

    ];
    @Output() valueChanged = new EventEmitter<string>();
    slides = [
        { img: "https://i.picsum.photos/id/419/200/200.jpg?hmac=yUYGIG3hJhzafcgOl8Drs4iTsia3HynizHXh8nTcvEQ" },
        { img: "https://i.picsum.photos/id/419/200/200.jpg?hmac=yUYGIG3hJhzafcgOl8Drs4iTsia3HynizHXh8nTcvEQ" },
        { img: "https://i.picsum.photos/id/419/200/200.jpg?hmac=yUYGIG3hJhzafcgOl8Drs4iTsia3HynizHXh8nTcvEQ" },
        { img: "https://i.picsum.photos/id/419/200/200.jpg?hmac=yUYGIG3hJhzafcgOl8Drs4iTsia3HynizHXh8nTcvEQ" },
        { img: "https://i.picsum.photos/id/419/200/200.jpg?hmac=yUYGIG3hJhzafcgOl8Drs4iTsia3HynizHXh8nTcvEQ" },
        { img: "https://i.picsum.photos/id/419/200/200.jpg?hmac=yUYGIG3hJhzafcgOl8Drs4iTsia3HynizHXh8nTcvEQ" },

    ];
    slideConfig = { "slidesToShow": 1, "slidesToScroll": 1 };
    slideConfigpv = { "slidesToShow": 1, "slidesToScroll": 1 };

    // @ViewChild(SlickCarouselComponent) slickCarousel: SlickCarouselComponent;
    @ViewChild('slickCarousel', { static: true }) slickCarousel: SlickCarouselComponent;

    ///////////////////////////////// Plant detail Graphical View ///////////////////////////////////////////////////////////


    @ViewChild(BaseChartDirective) chart: BaseChartDirective;

    ChartBoundary: number = 5;

    public lineChartColors: Array<any> = [
        { // Series A
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            borderColor: 'rgba(251, 140, 4, 1)',
        },
        { // Series B
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            borderColor: 'rgba(250, 98, 100, 1)',
        },
        { // Series C
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            borderColor: 'rgba(125, 125, 0, 1)',
        },
        { // Series D
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            borderColor: 'rgba(120, 120, 150, 1)',
        },
        { // Series E
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            borderColor: 'rgba(0, 10, 100, 100)',
        }
        // Add more color configurations for additional series
    ];


    graphViewData: Array<any> = [];
    public lineChartData: Array<any> = [
        {
            data: [65, 59, 80, 81, 56, 55, 40, 65, 59, 35, 55, 45, 67, 39, 81, 72, 80, 81, 56, 55, 40],

            // data: [],
            // label: '',
            backgroundColor: this.lineChartColors[0].backgroundColor,
            borderColor: this.lineChartColors[0].borderColor,
        },
        {
            data: [28, 48, 40, 35, 55, 45, 67, 39, 81, 72, 19, 86, 27, 90, 28, 48, 40, 19, 86, 27, 90],
            // data: [],
            // label: '',        
            backgroundColor: this.lineChartColors[1].backgroundColor,
            borderColor: this.lineChartColors[1].borderColor,
        },
        {
            data: [18, 48, 77, 9, 100, 27, 40, 18, 48, 77, , 35, 55, 45, 67, 39, 81, 29, 100, 27, 40],
            // data: [],
            // label: '',        
            backgroundColor: this.lineChartColors[2].backgroundColor,
            borderColor: this.lineChartColors[2].borderColor,
        },
        {
            data: [55, 80, 45, 75, 27, 68, 34, 55, 80, 35, 55, 45, 67, 39, 81, 72, 45, 75, 27, 68, 34],
            // data: [],
            // label: '',
            backgroundColor: this.lineChartColors[3].backgroundColor,
            borderColor: this.lineChartColors[3].borderColor,
        },
        {
            data: [35, 55, 45, 67, 35, 55, 45, 67, 39, 81, 72, 39, 81, 72, 35, 55, 45, 67, 39, 81, 72],
            // data: [],
            // label: '' ,        
            backgroundColor: this.lineChartColors[4].backgroundColor,
            borderColor: this.lineChartColors[4].borderColor,
        },
    ];

    public lineChartLabels: Array<any> = [];

    public lineChartOptions: any = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            yAxes: [
                {
                    type: 'time',
                    time: {
                        unit: 'second', // Change this to 'minute', 'hour', 'day', etc. as needed
                        unitStepSize: 5,
                        displayFormats: {
                            second: 'HH:mm:ss', // Format for the Y-axis labels
                        },
                    },
                },
            ],
        },

        interaction: {
            mode: 'index',
            intersect: false,
        },
        tooltips: {
            mode: 'index',
            intersect: false,
            position: 'nearest', // Set the position to 'nearest'
            callbacks: {
                label: function (tooltipItem, data) {
                    var datasetLabel =
                        data.datasets[tooltipItem.datasetIndex].label || '';
                    return datasetLabel + ': ' + tooltipItem.yLabel;
                },
            },
        },
    };

    public lineChartLegend = true;
    public chartType: 'line' | 'bar' | 'doughnut' = 'line'; // Use a union type for valid chart types




    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    /////////////////////////////////////////////// Heat Map ////////////////////////////////////////////////////////////////
    mapConnected = 0;
    mapDisconnected = 0;
    mapFaulty = 0;
    mapOffline = 0;

    series: any;

    formatTimestamp = (timestamp: number | string): string => {
        let date;

        if (typeof timestamp === 'string') {
            date = new Date(timestamp);
        } else {
            date = new Date(Number(timestamp) * 1000);
        }

        if (this.yearlyRoi === true) {
            return date.toLocaleString('default', { year: 'numeric' });
        }
        if (this.monthlyRoi === true) {
            date = new Date(timestamp);
            return date.toLocaleString('default', { month: 'short', year: 'numeric' });
        }
    };


    // Function to get the range of years from the timestamps
    getYearRange = (timestamps: number[] | string[]): string => {
        const years = timestamps.map(timestamp => new Date(timestamp).getFullYear());
        const minYear = Math.min(...years);
        const maxYear = Math.max(...years);
        if (minYear === maxYear) {
            return `(${maxYear})`
        }
        return `(${minYear} - ${maxYear})`;
    };
    monthlyRoi: boolean = false
    yearlyRoi: boolean = true
    installationCost: string
    categories = [];
    seriesData = [];
    yearRangeTitle = '';
    breakEvenYear = '';
    responseMessage = ''
    convertRoiAmount(valueInPKR) {
        if (valueInPKR >= 1000000000) {
            const valueInBillions = valueInPKR / 1000000000;
            return `${valueInBillions.toFixed(2)}B`;
        } else if (valueInPKR >= 1000000) {
            const valueInMillions = valueInPKR / 1000000;
            return `${valueInMillions.toFixed(2)}M`;
        } else if (valueInPKR >= 1000) {
            const valueInThousands = valueInPKR / 1000;
            return `${valueInThousands.toFixed(2)}K`;
        } else {
            return valueInPKR.toFixed(2);
        }
    }
    predictedData1 = []
    predictedRoiData = []
    roiParameters = {}

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    graphTabs: { key: 'day' | 'month' | 'year' | 'lifeTime'; label: string }[] = [
        { key: 'day', label: 'Day' },
        { key: 'month', label: 'Month' },
        { key: 'year', label: 'Year' },
        { key: 'lifeTime', label: 'Life Time' },
    ];

    get activeGraphTab(): 'day' | 'month' | 'year' | 'lifeTime' {
        if (this.monthWisePG) return 'month';
        if (this.yearWisePG) return 'year';
        if (this.lifetTimeWisePG) return 'lifeTime';
        return 'day';
    }

    get graphTitle(): string {
        const titles = { day: 'Day Wise', month: 'Month Wise', year: 'Year Wise', lifeTime: 'Life Time' };
        return titles[this.activeGraphTab];
    }
    constructor(private _utilityService: UtilityService, private predictionParamService: PredictedRoiService, private datePipe: DatePipe, private formBuilder: FormBuilder, private cdr: ChangeDetectorRef, private modalService: NgbModal,
        private toaster: ToastrService, private permService: PermissionsService,
        private _route: ActivatedRoute, private _router: Router,) {
        Object.assign(this, {});
        this.dt = new Date().toISOString().slice(0, 10);
        this.dtEnv = new Date().toISOString().slice(0, 10);
        this.dtEmiEnv = new Date().toISOString().slice(0, 10);
        // this.pvMultilineChartOptions = {
        //     chart: {},
        //     xAxis: [],
        //     yAxis: [],
        //     series: [],
        //     plotOptions: { series: {} }
        // };
    }
    RoiChartinit() {
        this.roiChart = {
            chart: {
                type: 'line',
                backgroundColor: 'transparent'
            },
            title: {
                text: null
            },
            credits: {
                enabled: false
            },
            xAxis: {
                categories: this.categories,
                title: {
                    text: this.yearRangeTitle,
                    y: 10,
                },
                lineWidth: 1,
                lineColor: '#000',
                tickColor: '#000',
                tickWidth: 1,
                style: {
                    fontFamily: 'Inter',
                    margin: '20px' // Adjust the margin value to add padding
                },
            },
            yAxis: {
                title: {
                    text: '(Amount)',
                    x: -10,
                },
                lineWidth: 1,
                lineColor: '#000',
                tickColor: '#000',
                tickWidth: 1,
                gridLineWidth: 1,
                gridLineDashStyle: 'longdash',
                plotLines: [{
                    color: '#FF0000', // Plot line color
                    width: 1,
                    value: 0,
                    zIndex: 2
                }],
                labels: {
                    formatter: function () {
                        return this.value.toLocaleString('en-US');
                    }
                }
            },
            legend: {
                align: 'left',
                verticalAlign: 'top',
                enabled: true,
                symbolWidth: 50,
                symbolHeight: 10,
            },
            plotOptions: {
                series: {
                    events: {
                        legendItemClick: function (event) {
                            if (event.target.name === 'Predicted Payback') {
                                this.predictedPaybackClicked = true;
                                this.reassignCategories(this.actualCategories, this.allCategories);
                            }
                        }
                    }
                }
            },
            series: [{
                name: 'Payback',
                showInLegend: true,
                data: this.seriesData,
                color: '#F2C14E',  // Color for the line
                marker: {
                    fillColor: '#EF4323',  // Color for the points
                    lineWidth: 2,
                    lineColor: '#F2C14E'  // Outline color for the points, usually same as line color
                }
            },
            {
                name: 'Predicted Payback',
                data: this.yearlyRoi ? this.predictedData1 : [],
                showInLegend: true,
                dashStyle: 'Dash',
                color: '#9cf11a',
                marker: {
                    fillColor: '#9cf11a',
                    lineWidth: 2,
                    lineColor: '#a5fc6c',
                    symbol: 'circle'
                }
            }
            ]
        };
        // }
    }


    reassignCategories(actualCategories, allCategories) {
        if (this.predictedPaybackClicked) {
            this.categories = actualCategories;
        } else {
            this.categories = allCategories;
        }
    }


    ngOnInit(): void {
        this.loader = true;
        this.initComponent()
        if (!this.selectedYear) {
            const currentDate = new Date();
            this.selectedYear = this.datePipe.transform(currentDate, 'yyyy');
            const formattedDate = this.datePipe.transform(new Date(this.selectedYear), 'yyyy-MM-dd');
            this.selectedDate = formattedDate;
        }
        if (!this.selectedMonth) {
            const currentDate = new Date();
            const month = currentDate.getMonth() + 1;
            const year = currentDate.getFullYear();
            this.selectedMonth = `${month}/${year}`;
            const formattedDate = this.datePipe.transform(currentDate, 'yyyy-MM-dd');
            this.selectedDate = formattedDate;
        }
        if (!this.selectedDay) {
            const currentDate = new Date();
            this.selectedDay = this.datePipe.transform(currentDate, 'dd/MM/yyyy');
            const formattedDate = this.datePipe.transform(currentDate, 'yyyy-MM-dd');
            this.selectedDate = formattedDate;
        }
        this._utilityService.selectedProduct$.subscribe((value) => {
            this.getStationCode = value;
        });
        this._utilityService.selectedPlantName$.subscribe((plantName: string) => {
            this.selectedPlantName = plantName;
        });
        // The URL is the source of truth: on a refresh or a deep link the
        // service subjects are empty, so seed them from the :id param.
        const routeStationCode = this._route.snapshot.paramMap.get('id');
        if (routeStationCode && String(this.getStationCode) !== routeStationCode) {
            this.getStationCode = routeStationCode;
            this._utilityService.setProduct(routeStationCode);
            // Any name still in the service belongs to a different plant —
            // drop it so the title and breadcrumb wait for this one's,
            // which getPlantDetailList() fills in from the response.
            this._utilityService.updateSelectedPlantName('');
        }
        this.getWeatherUpdates();
        this.getPlantDetailList();
        this.envirmentBanifit();
        this.getpowerFlow();
        this.showAlert();
        this.selectInverterDetail();
        this.pvDataList();
        this.getAlarmStatus(this.getStationCode);
        this.geHeatMapData();

        this.loader = false;
        this.dateClearEnv(this.selectedDate)
        // this.fiveMinData();
        this.EmiGraph(this.dtEnv);

        this.predictionParameterForm = this.formBuilder.group({
            cost: [null, [Validators.required, Validators.minLength(3), Validators.maxLength(11)]],
            // date: [null, [Validators.required]],
            baseProduction: [null, [Validators.required, Validators.minLength(3), Validators.maxLength(11)]],
            nextYearProduction: [null, [Validators.required, Validators.minLength(3), Validators.maxLength(11)]],
            tariffRate: [null, [Validators.required, Validators.pattern(/^100$|^\d{1,2}(\.\d{1,2})?$/)]],
            dipPercentage: [null, [Validators.required, Validators.pattern(/^100$|^\d{1,2}(\.\d{1,2})?$/)]]
        })

    }
    async initComponent() {
        this.loader = true
        await this.getComponentPermissions();
    }

    async getComponentPermissions() {
        const url = this.permService.getCurrentUrl();
        // const menuFromLocal = this.permService.loadMenuFromLocalStorage();
        const menuFromLocal = await this.permService.waitForMenuInLocalStorage();

        const matchedMenu = this.permService.findMenuPermissions(menuFromLocal, url);

        this.permissions = matchedMenu
            ? {
                canAdd: !!matchedMenu.canAdd,
                canEdit: !!matchedMenu.canEdit,
                canView: !!matchedMenu.canView,
                canDelete: !!matchedMenu.canDelete
            }
            : { ...DEFAULT_PERMISSIONS };

        this.permissionsReady = true;
    }
    get hasAnyActionPermission(): boolean {
        return (
            this.permissionsReady &&
            (this.permissions.canView ||
                this.permissions.canEdit ||
                this.permissions.canDelete)
        );
    }

    ngAfterViewInit(): void {
    }

    getMonthlyRoiGraph() {
        this.loader = true;
        this._utilityService.monthlyRoiGraph(this.getStationCode).subscribe(res => {
            if (res && res.status === 200) {
                this.loader = false;
                this.monthlyRoi = true;
                this.yearlyRoi = false;
                this.installationCost = this.convertToThousandsMillions(res.installation_cost)
                this.seriesData = res.data.map(item => item['payback']);
                this.categories = res.data.map(item => this.formatTimestamp(item['collectTime']));
                this.yearRangeTitle = this.getYearRange(res.data.map(item => item['collectTime']));
                if (!this.seriesData || this.seriesData.length === 0) {
                    this.responseMessage = "Please add Installation Cost and Ensure Plant Association with Tariff Type and Tariff Company."
                }
                this.RoiChartinit()

            }
            else {
                this.loader = false;
                this.seriesData = []
                this.categories = []
                this.yearRangeTitle = ''
                this.monthlyRoi = true;
                this.yearlyRoi = false
                if (!this.seriesData || this.seriesData.length === 0) {
                    this.responseMessage = "Please add Installation Cost and Ensure Plant Association with Tariff Type and Tariff Company."
                }
            }
        })
            , error => {
                this.loader = false;
                this.responseMessage = error.error.message;
                console.error('Error fetching ROI graph data:', error);
            }
    }

    findBreakEvenYear(predictedData: string | any[], installationCost?: any | number) {
        let closestDiff = Infinity;
        let breakEvenYear = null;
        for (let i = 0; i < predictedData.length; i++) {
            if (predictedData[i].predicted_payback >= 0) {
                breakEvenYear = this.categories[i];
                break;
            }
        }

        return breakEvenYear;
    }

    getYearlyRoiGraph() {
        this.loader = true;
        this._utilityService.getYearlyRoiGraph(this.getStationCode).subscribe(res => {
            if (res && res.status === 200) {
                this.loader = false;
                this.monthlyRoi = false;
                this.yearlyRoi = true;

                const actualDataMap = new Map(res.data['yearly_roi'].map(item => [this.formatTimestamp(item['collectTime']), item['payback']]));
                this.installationCost = this.convertToThousandsMillions(res.installation_cost)
                this.actualCategories = [...actualDataMap.keys()];
                const predictedDataMap = new Map(res.data['predicted_roi'].map(item => [this.formatTimestamp(item['collectTime']), item['predicted_payback']]));
                const predictedCategories = [...predictedDataMap.keys()];

                this.roiParameters = res.parameters

                this.allCategories = [...new Set([...this.actualCategories, ...predictedCategories])].sort();
                this.categories = this.allCategories;

                this.seriesData = this.categories.map(category => actualDataMap.get(category) || null);
                this.predictedData1 = this.categories.map(category => predictedDataMap.get(category) || null);

                // this.yearRangeTitle = this.getYearRange(res.data['yearly_roi'].map(item => item['collectTime']));
                this.yearRangeTitle = this.getYearRange(this.allCategories);
                // this.breakEvenYear = this.findBreakEvenYear(res.data.predicted_roi, this.installationCost);
                this.breakEvenYear = res.break_even_year;


                if (!this.seriesData || this.seriesData.length === 0) {
                    this.responseMessage = "Please add Installation Cost and Ensure Plant Association with Tariff Type and Tariff Company."
                }
                this.RoiChartinit()
            }
            else {
                this.loader = false;
                this.seriesData = []
                this.monthlyRoi = false
                this.categories = []
                this.yearRangeTitle = ''
                if (!this.seriesData || this.seriesData.length === 0) {
                    this.responseMessage = "Please add Installation Cost and Ensure Plant Association with Tariff Type and Tariff Company."
                }
            }
        })
    }
    getAlarmStatus(StationCode: any) {
        this._utilityService.GetPlantAlarmCount(StationCode).subscribe((res) => {
            for (var item of res.data.alarm_status) {
                if (item.alarm_type == 'Critical') {
                    this.alarmSts.Critical = item.count;
                }
                else if (item.alarm_type == 'Major') {
                    this.alarmSts.Major = item.count;
                }
                else if (item.alarm_type == 'Minor') {
                    this.alarmSts.Minor = item.count;
                }
                else if (item.alarm_type == 'Warning') {
                    this.alarmSts.Warning = item.count;
                }
            };

            this.alarmSts.TotalAlarms = this.alarmSts.Critical + this.alarmSts.Major + this.alarmSts.Minor + this.alarmSts.Warning;

            this.series = [
                {
                    "name": "Critical",
                    "value": (this.alarmSts.Critical / this.alarmSts.TotalAlarms * 100).toFixed(1),
                    "label": Math.round((this.alarmSts.Critical / this.alarmSts.TotalAlarms * 100)).toString() + "%"
                },
                {
                    "name": "Major",
                    "value": (this.alarmSts.Major / this.alarmSts.TotalAlarms * 100).toFixed(1),
                    "label": Math.round((this.alarmSts.Major / this.alarmSts.TotalAlarms * 100)).toString() + "%"
                },
                {
                    "name": "Minor",
                    "value": (this.alarmSts.Minor / this.alarmSts.TotalAlarms * 100).toFixed(1),
                    "label": Math.round((this.alarmSts.Minor / this.alarmSts.TotalAlarms * 100)).toString() + "%"
                },
                {
                    "name": "Warning",
                    "value": (this.alarmSts.Warning / this.alarmSts.TotalAlarms * 100).toFixed(1),
                    "label": Math.round((this.alarmSts.Warning / this.alarmSts.TotalAlarms * 100)).toString() + "%"
                }
            ];
        });
    }

    showPlantList() {
        this._utilityService.setUrl(false);
        this._router.navigate(['/plant-management/plants']);
    }

    sendDeviD(value: string) {
        this.valueChanged.emit(value);
    }

    getBackgroundColor(colorValue: string): string {
        // Map color values to corresponding colors
        if (colorValue === 'Red') {
            return '#E8837A'; // Soft red
        } else if (colorValue === 'Green') {
            return '#6FCF97'; // Soft green
        } else if (colorValue === 'Faulty') {
            return '#E8837A'; // Soft red
        }
        else {
            return '';
        }
    }


    ngDoCheck() {
    }
    onSelect(data): void {
    }
    onActivate(data): void {
    }
    onDeactivate(data): void {
        console.log('Deactivate', JSON.parse(JSON.stringify(data)));
    }

    getWeatherUpdates() {
        this._utilityService
            .setWeatherUpdates(this.getStationCode)
            .subscribe((res) => {
                if (res) {
                    this.weather = res.data;
                }
            });
    }

    geHeatMapData() {
        this._utilityService
            .getHeatMapList(this.getStationCode)
            .subscribe((res) => {
                if (res) {
                    //debugger;
                    this.heatMapList = res;
                }
            });
    }

    // SetGraphData(): void {
    //     //debugger;

    //     // Replace 5 with your desired constant value

    //     for (let index = 0; index < this.ChartBoundary; index++) {
    //         //this.lineChartData[index].data.length = 0;
    //         this.lineChartData[index].label = "";
    //     }

    //     const filteredObjects = this.pvGraphKey.filter(obj => obj.status === 1 || obj.status === true);

    //     let index = 0;

    //     filteredObjects.forEach((e) => {
    //         if (index < this.ChartBoundary) {
    //             this.lineChartData[index].data = this.pvGraphRes[0][e.name];
    //             this.lineChartData[index].label = e.value;
    //             index = index + 1;
    //         }
    //     });

    //     this.graphViewData.length = 0;

    //     //debugger;
    //     this.lineChartData.forEach((obj) => {
    //         if (!(obj.label === undefined || obj.label === null || obj.label === "")) {
    //             if (obj.data.length > 0)
    //                 this.graphViewData.push(obj);
    //         }
    //     });

    //     this.chart.update();
    //     this.cdr.detectChanges();
    // }

    getPlantDetailList() {
        this.powerGauge = [];
        this.ShowPowerGuage = false;
        this._utilityService
            .setPlantDetailList(this.getStationCode)
            .subscribe((res) => {
                if (res) {
                    //debugger;
                    this.plantDetail = res.data[0];
                    // On a cold open the header has no name yet — take it from the response.
                    if (!this.selectedPlantName && this.plantDetail?.plantName) {
                        this.selectedPlantName = this.plantDetail.plantName;
                        this._utilityService.updateSelectedPlantName(this.plantDetail.plantName);
                    }
                    this.plantDetail.costFormatted = this.convertToThousandsMillions(this.plantDetail.cost)
                    this.powerGauge = [
                        {
                            name: 'Power',
                            value: this.plantDetail.powerNow,
                        },
                    ];
                }

                setTimeout(() => {
                    this.ShowPowerGuage = true;
                    this.getYearlyRoiGraph();
                }, 1000);
            });
    }

    convertToThousandsMillions(valueInPKR, limitThousands = 10000, limitMillions = 1000000) {
        if (valueInPKR >= limitMillions) {
            const valueInMillions = valueInPKR / 1000000;
            return `${valueInMillions.toFixed(2)} million PKR`;
        } else if (valueInPKR >= limitThousands) {
            const valueInThousands = valueInPKR / 1000;
            return `${valueInThousands.toFixed(2)}k PKR`;
        } else {
            return `${valueInPKR.toFixed(2)} PKR`;
        }
    }


    showAlert() {
        this._utilityService
            .countAlertlist(this.getStationCode)
            .subscribe((res) => {
                if (res) {
                    this.countAlert = res.data;
                }
            });
    }

    sendDate(e: any) {
        this.getDayRang = e.target.value;
        this.dymont = e.target.value;
        this.envirmentBanifit();
        this.status = this.status;
    }

    onIrradianceDateChange(date: Date | null) {
        if (!date) return;
        this.EmiGraph(this.datePipe.transform(date, 'yyyy-MM-dd'));
    }

    EmiGraph(e) {
        //debugger;
        this.emiGraphLoader = true;

        this.dtEnv = e;
        this.emiPraghcollectTime = [];
        this.emiPraghRadiant = [];
        this.blockinfo = [];
        this._utilityService
            .setEmiGraphWithDate(this.getStationCode, this.dtEnv)
            .subscribe((res) => {
                // debugger;
                this.totalhistory = res.data;
                this.emiGraphLoader = false;

                if (this.totalhistory?.length > 0) {
                    var blocklist = [];
                    var Consumptionlist = [];
                    blocklist = res.data;
                    // Consumptionlist = res.data.consumptionData;
                    blocklist.forEach((e) => {
                        ////debugger                  

                        const date = new Date(Number(e.collectTime) * 1000);
                        const time = this.datePipe.transform(date, 'hh:mm a');
                        this.emiPraghcollectTime.push(
                            time
                        );

                        this.emiPraghRadiant.push(+(e.radiant_line));
                    });

                } else {
                    this.showhistory = true;
                }
                this.EmiChartGraph = {
                    chart: { backgroundColor: 'transparent' },   // ADD
                    title: {
                        text: '',

                        style: {
                            color: 'black',
                            align: 'left'
                        }
                    },

                    xAxis: {
                        categories: this.emiPraghcollectTime,
                        title: {
                            text: '<b >Time</b>'
                        }
                    },
                    yAxis: {
                        min: 0,
                        title: {
                            text: '<b >Irradiance</b>',
                            align: 'middle'
                        },
                        labels: {
                            overflow: 'justify'
                        }
                    },
                    plotOptions: {
                        pie: {
                            allowPointSelect: true,
                            cursor: 'pointer',
                            dataLabels: {
                                enabled: true
                            },
                            showInLegend: true
                        }
                    },

                    series: [
                        {
                            name: 'Irradiance Values',
                            data: this.emiPraghRadiant,
                            //data: [31, 40, 28, 51, 42, 109, 100],
                            type: 'area',
                            color: '#AA4A56'
                        }
                        // ,
                        // {
                        //     name: 'Power Generated',
                        //     data: this.emiPraghRadiant,
                        //     type: 'area',
                        //     color: '#3E4A56'
                        // }
                    ]
                };
            },
                (error) => {
                    console.error('EMI API error:', error);
                    this.emiGraphLoader = false;
                });
    }


    envirmentBanifit() {
        this._utilityService
            .getEnvBnifits(this.getStationCode, this.dt, this.getDayRang)
            .subscribe((res) => {
                if (res) {
                    //debugger;                    
                    this.evnrBanifits = res.data[0];
                }
            });
    }
    dateClear(e) {
        this.loader = true;
        this.envirmentBanifit();
        this.dt = e;
        this.loader = false;
    }

    onTabChange(type: 'day' | 'month' | 'year' | 'lifeTime') {
        const today = new Date();
        this.blockOption = null;
        this.lineChartcollectTime = [];
        this.lineChartcollectcollect = [];
        this.lineChartcollectConsumption = [];
        this.lineChartcollectMainsPower = [];
        this.chartUpdateFlag = true;
        this.barChart = null;

        const formattedDay = this.datePipe.transform(today, 'dd/MM/yyyy');
        const formattedAPI = this.datePipe.transform(today, 'yyyy-MM-dd');
        // this.graphLoader = true;

        if (type === 'day') {
            this.selectedDay = formattedDay;
            this.selectedDate = formattedAPI;
            this.dayWisePG = true;
            this.monthWisePG = false;
            this.yearWisePG = false;
            this.lifetTimeWisePG = false;
            this.dateClearEnv(this.selectedDate);
        } else if (type === 'month') {
            this.selectedMonth = this.datePipe.transform(today, 'MM/YYYY');
            this.selectedDate = formattedAPI;
            this.dayWisePG = false;
            this.monthWisePG = true;
            this.yearWisePG = false;
            this.lifetTimeWisePG = false;
            this.monthChartInfo();
        } else if (type === 'year') {
            this.selectedYear = this.datePipe.transform(today, 'YYYY');
            this.selectedDate = formattedAPI;
            this.dayWisePG = false;
            this.monthWisePG = false;
            this.yearWisePG = true;
            this.lifetTimeWisePG = false;
            this.yearChartInfo();
        } else if (type === 'lifeTime') {
            this.selectedYear = this.datePipe.transform(today, 'YYYY');
            this.selectedDate = formattedAPI;
            this.dayWisePG = false;
            this.monthWisePG = false;
            this.yearWisePG = false;
            this.lifetTimeWisePG = true;
            this.lifeTimeChartInfo();
        }
        console.log(this.lifetTimeWisePG)
        // this.graphLoader = false;
    }


    dayWiseCheck(selectedMonth: string) {
        const selectedDate = new Date(selectedMonth);
        const formattedDate = this.datePipe.transform(selectedDate, 'yyyy-MM-dd');

        // this.loader = true;
        this.selectedDate = formattedDate;
        this.dateClearEnv(formattedDate);
    }
    canNavigateNext: boolean = false;
    canNavigatePrevious: boolean = true;
    navigatePrevious() {
        if (!this.selectedDate) return;

        const currentDate = new Date(this.selectedDate);

        if (this.dayWisePG) {
            // Previous day
            currentDate.setDate(currentDate.getDate() - 1);
            const formattedDate = this.datePipe.transform(currentDate, 'yyyy-MM-dd');
            this.selectedDay = this.datePipe.transform(currentDate, 'dd/MM/yyyy');
            this.selectedDate = formattedDate;
            this.dateClearEnv(formattedDate);
        } else if (this.monthWisePG) {
            // Previous month
            currentDate.setMonth(currentDate.getMonth() - 1);
            const formattedDate = this.datePipe.transform(currentDate, 'yyyy-MM-dd');
            this.selectedMonth = this.datePipe.transform(currentDate, 'MM/YYYY');
            this.selectedDate = formattedDate;
            this.monthChartInfo();
        } else if (this.yearWisePG) {
            // Previous year
            currentDate.setFullYear(currentDate.getFullYear() - 1);
            const formattedDate = this.datePipe.transform(currentDate, 'yyyy-MM-dd');
            this.selectedYear = this.datePipe.transform(currentDate, 'YYYY');
            this.selectedDate = formattedDate;
            this.yearChartInfo();
        }

        this.updateNavigationButtons();
    }

    // Navigate to next day/month/year
    navigateNext() {
        if (!this.selectedDate || !this.canNavigateNext) return;

        const currentDate = new Date(this.selectedDate);

        if (this.dayWisePG) {
            // Next day
            currentDate.setDate(currentDate.getDate() + 1);
            const formattedDate = this.datePipe.transform(currentDate, 'yyyy-MM-dd');
            this.selectedDay = this.datePipe.transform(currentDate, 'dd/MM/yyyy');
            this.selectedDate = formattedDate;
            this.dateClearEnv(formattedDate);
        } else if (this.monthWisePG) {
            // Next month
            currentDate.setMonth(currentDate.getMonth() + 1);
            const formattedDate = this.datePipe.transform(currentDate, 'yyyy-MM-dd');
            this.selectedMonth = this.datePipe.transform(currentDate, 'MM/YYYY');
            this.selectedDate = formattedDate;
            this.monthChartInfo();
        } else if (this.yearWisePG) {
            // Next year
            currentDate.setFullYear(currentDate.getFullYear() + 1);
            const formattedDate = this.datePipe.transform(currentDate, 'yyyy-MM-dd');
            this.selectedYear = this.datePipe.transform(currentDate, 'YYYY');
            this.selectedDate = formattedDate;
            this.yearChartInfo();
        }

        this.updateNavigationButtons();
    } updateNavigationButtons() {
        if (!this.selectedDate) {
            this.canNavigateNext = false;
            this.canNavigatePrevious = true;
            return;
        }

        const currentDate = new Date(this.selectedDate);
        const today = new Date();

        // Reset time to compare only dates
        currentDate.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);

        if (this.dayWisePG) {
            // For day view: can't go to future dates
            this.canNavigateNext = currentDate < today;
        } else if (this.monthWisePG) {
            // For month view: can't go to future months
            const currentMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
            const todayMonth = new Date(today.getFullYear(), today.getMonth(), 1);
            this.canNavigateNext = currentMonth < todayMonth;
        } else if (this.yearWisePG) {
            // For year view: can't go to future years
            this.canNavigateNext = currentDate.getFullYear() < today.getFullYear();
        }

        // Can always go to previous (assuming you have historical data)
        this.canNavigatePrevious = true;
    }

    // monthWIseCheck(e) {
    //     this.loader = true;
    //     this.dt = e;
    //     this.monthChartInfo();
    //     this.loader = false;
    // }
    monthWiseCheck(selectedMonth: string) {
        this.selectedDay = this.datePipe.transform(new Date(), 'dd/MM/yyyy');
        const selectedDate = new Date(selectedMonth);

        // Format the date using DatePipe
        const formattedDate = this.datePipe.transform(selectedDate, 'yyyy-MM-dd');

        // this.loader = true;
        this.selectedDate = formattedDate;
        this.monthChartInfo();
        this.loader = false;
    }

    // yearWIseCheck(e) {
    //     this.loader = true;
    //     this.dt = e;
    //     this.yearChartInfo();
    //     this.loader = false;
    // }
    yearWiseCheck(selectedYear: string) {
        const selectedDate = new Date(selectedYear);

        const formattedDate = this.datePipe.transform(selectedDate, 'yyyy-MM-dd');

        this.loader = true;
        this.selectedDate = formattedDate;
        this.yearChartInfo();
        this.loader = false;
    }
    clickEvent() {
        this.status = !this.status;
    }

    dateClearEnv(e) {
        this.graphLoader = true;
        this.dtEnv = e;

        this.lineChartcollectTime = [];
        this.lineChartcollectcollect = [];
        this.lineChartcollectConsumption = [];
        this.lineChartcollectMainsPower = [];
        this.blockinfo = [];
        this.totalhistory = [];
        this.blockOption = null;
        this.chartUpdateFlag = false;

        this._utilityService
            .setfiveMinDataWithDate(this.getStationCode, this.selectedDate)
            .subscribe((res) => {
                this.dayWisePG = true;
                this.monthWisePG = false;
                this.yearWisePG = false;

                this.totalhistory = res.data.data;
                if (this.totalhistory?.length > 0) {
                    const blocklist = res.data.data;

                    blocklist.forEach((e) => {
                        const date = new Date(Number(e.timestamp) * 1000);
                        const time = this.datePipe.transform(date, 'hh:mm a');

                        this.lineChartcollectTime.push(time);

                        const generation = e.generation === 0 ? null : parseFloat(e.generation.toFixed(2));
                        const consumption = e.consumption === 0 ? null : parseFloat(e.consumption.toFixed(2));
                        const mainsPower = e.mains_power === 0 ? null : parseFloat(e.mains_power.toFixed(2));

                        this.lineChartcollectcollect.push(generation);
                        this.lineChartcollectConsumption.push(consumption);
                        this.lineChartcollectMainsPower.push(mainsPower);
                    });

                    // Calculate dynamic min and max for y-axis
                    const allValues = [
                        ...this.lineChartcollectcollect.filter(v => v !== null),
                        ...this.lineChartcollectConsumption.filter(v => v !== null),
                        ...this.lineChartcollectMainsPower.filter(v => v !== null)
                    ];

                    const minValue = Math.min(...allValues);
                    const maxValue = Math.max(...allValues);

                    // Apply padding separately for positive and negative sides
                    let yMin, yMax;

                    if (minValue < 0) {
                        // Add 10% padding to negative values
                        yMin = Math.floor(minValue * 1.1);
                    } else {
                        yMin = 0;
                    }

                    if (maxValue > 0) {
                        // Add 10% padding to positive values
                        yMax = Math.ceil(maxValue * 1.1);
                    } else {
                        yMax = 0;
                    }

                    this.blockOption = {
                        chart: { backgroundColor: 'transparent' },   // ADD
                        title: {
                            text: '',
                            style: { color: 'black', align: 'left' }
                        },
                        xAxis: {
                            categories: this.lineChartcollectTime,
                            title: { text: '<b>Time</b>' }
                        },
                        yAxis: {
                            min: yMin, // Dynamically calculated minimum
                            max: yMax, // Dynamically calculated maximum
                            title: { text: '<b>Power</b>', align: 'middle' },
                            labels: { overflow: 'justify' },
                            plotLines: [{
                                value: 0,
                                color: '#999',
                                width: 1,
                                zIndex: 3
                            }] // Add a line at zero for clarity
                        },
                        tooltip: {
                            shared: true, // Show all series in one tooltip
                            // crosshairs: true, // Show crosshair lines

                        },
                        plotOptions: {
                            // area: {
                            //     fillColor: {
                            //         linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
                            //         stops: [
                            //             [0, '#2CD391'],
                            //             [1, 'rgba(44, 211, 145, 0.2)']
                            //         ]
                            //     },
                            //     lineColor: '#2CD391',
                            //     marker: {
                            //         enabled: false
                            //     },
                            //     threshold: null
                            // }
                        },
                        // legend: {
                        //     enabled: true,
                        //     align: 'right',
                        //     verticalAlign: 'top',
                        //     layout: 'vertical',
                        //     floating: true,
                        //     backgroundColor: '#FFFFFF',
                        //     borderWidth: 1,
                        //     shadow: false
                        // },
                        series: [
                            {
                                name: 'Power Consumed',
                                data: this.lineChartcollectConsumption,
                                type: 'area',
                                color: '#EF4323',
                                fillColor: {
                                    linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
                                    stops: [
                                        [0, '#EF4323'],
                                        [1, 'rgba(239, 67, 35, 0.2)']
                                    ]
                                }
                            },
                            {
                                name: 'Power Generated',
                                data: this.lineChartcollectcollect,
                                type: 'area',
                                color: '#2CD391',
                                fillColor: {
                                    linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
                                    stops: [
                                        [0, '#2CD391'],
                                        [1, 'rgba(44, 211, 145, 0.2)']
                                    ]
                                }
                            },
                            {
                                name: 'Mains Power',
                                data: this.lineChartcollectMainsPower,
                                type: 'area',
                                color: '#808080',
                                fillColor: {
                                    linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
                                    stops: [
                                        [0, '#808080'],
                                        [1, 'rgba(128, 128, 128, 0.2)']
                                    ]
                                }
                            }
                        ]
                    };

                    setTimeout(() => {
                        this.showhistory = false;
                        this.chartUpdateFlag = true;
                        this.graphLoader = false;
                    }, 0);

                } else {
                    this.showhistory = true;
                }
                // if (this.totalhistory?.length > 0) {
                //     const blocklist = res.data.data;

                //     blocklist.forEach((e) => {
                //         const date = new Date(Number(e.timestamp) * 1000);
                //         const time = this.datePipe.transform(date, 'hh:mm a');

                //         this.lineChartcollectTime.push(time);

                //         const generation = e.generation === 0 ? null : parseFloat(e.generation.toFixed(2));
                //         const consumption = e.consumption === 0 ? null : parseFloat(e.consumption.toFixed(2));
                //         const mainsPower = e.mains_power === 0 ? null : parseFloat(e.mains_power.toFixed(2));

                //         this.lineChartcollectcollect.push(generation);
                //         this.lineChartcollectConsumption.push(consumption);
                //         this.lineChartcollectMainsPower.push(mainsPower);
                //     });

                //     // Calculate dynamic min and max for y-axis
                //     const allValues = [
                //         ...this.lineChartcollectcollect.filter(v => v !== null),
                //         ...this.lineChartcollectConsumption.filter(v => v !== null),
                //         ...this.lineChartcollectMainsPower.filter(v => v !== null)
                //     ];

                //     const minValue = Math.min(...allValues);
                //     const maxValue = Math.max(...allValues);

                //     // Add 10% padding to min and max for better visualization
                //     const padding = (maxValue - minValue) * 0.1;
                //     const yMin = Math.floor(minValue - padding);
                //     const yMax = Math.ceil(maxValue + padding);

                //     this.blockOption = {
                //         title: {
                //             text: '',
                //             style: { color: 'black', align: 'left' }
                //         },
                //         xAxis: {
                //             categories: this.lineChartcollectTime,
                //             title: { text: '<b>Time</b>' }
                //         },
                //         yAxis: {
                //             min: yMin, // Dynamically calculated minimum
                //             max: yMax, // Dynamically calculated maximum
                //             title: { text: '<b>Power</b>', align: 'middle' },
                //             labels: { overflow: 'justify' }
                //         },
                //         // plotOptions: {
                //         //     area: {
                //         //         fillColor: {
                //         //             linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
                //         //             stops: [
                //         //                 [0, '#2CD391'],
                //         //                 [1, 'rgba(44, 211, 145, 0.2)']
                //         //             ]
                //         //         },
                //         //         lineColor: '#2CD391',
                //         //         marker: {
                //         //             enabled: false
                //         //         },
                //         //         threshold: null
                //         //     }
                //         // },
                //         legend: {
                //             enabled: true,
                //             align: 'right',
                //             verticalAlign: 'top',
                //             layout: 'vertical',
                //             floating: true,
                //             backgroundColor: '#FFFFFF',
                //             borderWidth: 1,
                //             shadow: false
                //         },
                //         series: [
                //             {
                //                 name: 'Power Consumed',
                //                 data: this.lineChartcollectConsumption,
                //                 type: 'area',
                //                 color: '#EF4323',
                //                 fillColor: {
                //                     linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
                //                     stops: [
                //                         [0, '#EF4323'],
                //                         [1, 'rgba(239, 67, 35, 0.2)']
                //                     ]
                //                 }
                //             },
                //             {
                //                 name: 'Power Generated',
                //                 data: this.lineChartcollectcollect,
                //                 type: 'area',
                //                 color: '#2CD391',
                //                 fillColor: {
                //                     linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
                //                     stops: [
                //                         [0, '#2CD391'],
                //                         [1, 'rgba(44, 211, 145, 0.2)']
                //                     ]
                //                 }
                //             },
                //             {
                //                 name: 'Mains Power',
                //                 data: this.lineChartcollectMainsPower,
                //                 type: 'area',
                //                 color: '#808080',
                //                 fillColor: {
                //                     linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
                //                     stops: [
                //                         [0, '#808080'],
                //                         [1, 'rgba(128, 128, 128, 0.2)']
                //                     ]
                //                 }
                //             }
                //         ]
                //     };

                //     setTimeout(() => {
                //         this.showhistory = false;
                //         this.chartUpdateFlag = true;
                //         this.graphLoader = false;
                //     }, 0);

                // } else {
                //     this.showhistory = true;
                // }

                this.graphLoader = false;
            },
                (error) => {
                    console.error('API error:', error);
                    this.graphLoader = false;  // ✅ Ensure the loader stops on failure
                    this.showhistory = true;   // 👀 Optional UI fallback
                    this.blockOption = null;
                }
            );
    }


    fiveMinData() {
        this.graphLoader = true;
        this.lineChartcollectTime = [];
        this.lineChartcollectcollect = [];
        this.lineChartcollectConsumption = [];
        this.lineChartcollectMainsPower = [];
        this.totalhistory = [];
        this.blockOption = null;
        this.blockinfo = [];
        this.chartUpdateFlag = false;
        this.showhistory = false; // Reset here at start
        this._utilityService.setfiveMinData(this.getStationCode).subscribe((res) => {
            // this._utilityService.setfiveMinDataWithDate(this.getStationCode,this.selectedDate).subscribe((res) => {
            this.dayWisePG = true;
            this.monthWisePG = false;
            this.yearWisePG = false;
            this.lifetTimeWisePG = false;
            this.totalhistory = res.data.data;

            if (this.totalhistory?.length > 0) {
                this.showhistory = false;
                this.graphLoader = false;

                const blocklist = res.data.data;
                blocklist.forEach((e) => {
                    const date = new Date(Number(e.timestamp) * 1000);
                    const time = this.datePipe.transform(date, 'hh:mm a');
                    this.lineChartcollectTime.push(time);

                    const generation = e.generation === 0 ? null : parseFloat(e.generation.toFixed(2));
                    const consumption = e.consumption === 0 ? null : parseFloat(e.consumption.toFixed(2));

                    this.lineChartcollectcollect.push(generation);
                    this.lineChartcollectConsumption.push(consumption);
                });

                // ✅ Only assign blockOption when data exists
                this.blockOption = {
                    chart: { backgroundColor: 'transparent' },   // ADD
                    title: {
                        text: '',
                        style: { color: 'black', align: 'left' }
                    },
                    xAxis: {
                        categories: this.lineChartcollectTime,
                        title: { text: '<b>Time</b>' }
                    },
                    yAxis: {
                        min: null,
                        title: { text: '<b>Power</b>', align: 'middle' },
                        labels: { overflow: 'justify' }
                    },
                    legend: {
                        enabled: true,
                        align: 'right',
                        verticalAlign: 'top',
                        layout: 'vertical',
                        floating: true,
                        backgroundColor: '#FFFFFF',
                        borderWidth: 1,
                        shadow: false
                    },
                    plotOptions: {
                        area: {
                            allowPointSelect: true,
                            cursor: 'pointer',
                            dataLabels: { enabled: false },
                            showInLegend: true,
                            fillColor: {
                                linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
                                stops: [
                                    [0, 'rgba(44, 211, 145, 1)'], // dark green top
                                    [1, 'rgba(44, 211, 145, 0.2)'] // light green fade bottom
                                ]
                            },
                            lineColor: '#2CD391',
                            marker: { enabled: false },
                            threshold: null
                        }
                    },
                    series: [
                        {
                            name: 'Power Consumed',
                            data: this.lineChartcollectConsumption,
                            type: 'area',
                            color: '#EF4323',
                            fillColor: {
                                linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
                                stops: [
                                    [0, '#EF4323'], // top
                                    [1, 'rgba(239, 67, 35, 0.2)'] // bottom fade
                                ]
                            }
                        },
                        {
                            name: 'Power Generated',
                            data: this.lineChartcollectcollect,
                            type: 'area',
                            color: '#2CD391',
                            fillColor: {
                                linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
                                stops: [
                                    [0, '#2CD391'], // dark green top
                                    [1, 'rgba(44, 211, 145, 0.2)'] // light green fade
                                ]
                            }
                        }
                    ]
                };


                this.chartUpdateFlag = true;

            } else {
                this.graphLoader = false;
                this.showhistory = true;
                this.blockOption = null;
            }
        },
            (error) => {
                console.error('API error:', error);
                this.graphLoader = false;  // ✅ Ensure the loader stops on failure
                this.showhistory = true;   // 👀 Optional UI fallback
                this.blockOption = null;
            }
        );

    }


    getpowerFlow() {
        this.showplantGraph = false;
        this._utilityService
            .getpowerFlowList(this.getStationCode)
            .subscribe((res) => {
                if (res) {
                    this.PlantPowerDetails = res.data[0];
                    this.showplantGraph = true;
                }
            });
    }

    roundNullToZero(value: any): number {
        if (isNaN(value) || value == undefined || value == null) {
            return 0;
        }

        if (value == 0.0)
            return 0;

        if (value == -0.0)
            return 0;

        return value;
    }

    roundOffOneDec(value: any) {

        if (isNaN(value) || value == undefined || value == null) {
            return 0;
        }
        return (parseFloat(value)).toFixed(1);
    }

    getHeatMap() {
        this.showplantGraph = false;
        this._utilityService
            .getHeatMapList(this.getStationCode)
            .subscribe((res) => {
                if (res) {
                    this.PlantPowerDetails = res.data[0];
                    this.showplantGraph = true;
                }
            });
    }

    monthChartInfo() {
        this.graphLoader = true;
        this.monthCartListInfo = [];
        this.monthCartListInfoPower = [];
        this.monthCartListInfoPowerConsumed = [];
        this.barChart = null;
        this._utilityService
            .getMonthChart(this.getStationCode, this.selectedDate)  // this.dt replaced by this.selectedDate
            .subscribe((res) => {
                if (res) {
                    this.monthWisePG = true;
                    this.yearWisePG = false;
                    this.dayWisePG = false;
                    this.lifetTimeWisePG = false
                    var monthCartList = [];
                    monthCartList = res.data;
                    ////debugger;
                    monthCartList.forEach((e) => {
                        const newdate = new Date(Number(e.timestamp) * 1000);

                        const datetime = this.datePipe.transform(newdate, 'yyyy-MM-dd'); //'dd/MM/yyyy'

                        this.monthCartListInfo.push(
                            //e.collectTime.toString().split('T')[0]
                            datetime
                        );
                        this.monthCartListInfoPower.push(e.powerGenerated);
                        this.monthCartListInfoPowerConsumed.push(e.powerConsumed);
                        // if(e.powerConsumed == null)
                        // {
                        //     this.monthCartListInfoPowerConsumed.push(e.powerGenerated);
                        // }
                        // else
                        // {
                        //     this.monthCartListInfoPowerConsumed.push(e.powerConsumed);
                        // }
                        // this.monthCartListInfo.push(
                        //     e.collectTime.toString().split('T')[0]
                        // );
                        // this.monthCartListInfoPower.push(e.power);

                    });

                    this.graphLoader = false;

                    ////debugger;
                }

                this.barChart = {
                    chart: { backgroundColor: 'transparent' },   // ADD
                    title: {
                        text: '',

                        style: {
                            color: 'green',
                            align: 'left'
                        }
                    },
                    xAxis: {
                        categories: this.monthCartListInfo,
                        title: {
                            text: '<b >Date</b>'
                        }
                    },
                    yAxis: {
                        min: null,
                        title: {
                            text: '<b >Power</b>',
                            align: 'middle'
                        },
                        labels: {
                            overflow: 'justify'
                        }
                    },
                    plotOptions: {
                        pie: {
                            allowPointSelect: true,
                            cursor: 'pointer',
                            dataLabels: {
                                enabled: false
                            },
                            showInLegend: true
                        }
                    },
                    // legend: {
                    //         enabled: true,
                    //         align: 'right',
                    //         verticalAlign: 'top',
                    //         layout: 'vertical',
                    //         floating: true,
                    //         backgroundColor: '#FFFFFF',
                    //         borderWidth: 1,
                    //         shadow: false
                    //     },

                    series: [
                        // {
                        //     name: 'Power',
                        //     data: this.monthCartListInfo,
                        //     color: '#3E4A56',
                        //     type: 'column'
                        // },
                        {
                            name: 'Power Consumed',
                            data: this.monthCartListInfoPowerConsumed,
                            color: '#EF4323',
                            type: 'column'
                        },
                        {
                            name: 'Power Genrated',
                            data: this.monthCartListInfoPower,
                            color: '#2CD391',
                            type: 'column'
                        }
                    ]
                };
            });

    }


    yearChartInfo() {
        this.graphLoader = true;
        this.monthCartListInfo = [];
        this.monthCartListInfoPower = [];
        this.monthCartListInfoPowerConsumed = [];
        this.barChart = null;
        this._utilityService
            .getyearChart(this.getStationCode, this.selectedDate)
            .subscribe((res) => {
                if (res) {

                    this.monthWisePG = false;
                    this.yearWisePG = true;
                    this.dayWisePG = false;
                    this.lifetTimeWisePG = false
                    var monthCartList = [];
                    monthCartList = res.data;
                    monthCartList.forEach((e) => {
                        const newdate = new Date(Number(e.timestamp) * 1000);
                        const datetime = this.datePipe.transform(newdate, 'yyyy-MM'); //'dd/MM/yyyy'
                        ////;
                        this.monthCartListInfo.push(
                            datetime
                        );
                        this.monthCartListInfoPower.push(e.powerGenerated);
                        this.monthCartListInfoPowerConsumed.push(e.powerConsumed);

                    });
                    this.graphLoader = false;
                }

                this.barChart = {
                    chart: { backgroundColor: 'transparent' },   // ADD

                    title: {
                        text: '',

                        style: {
                            color: 'green',
                            align: 'left'
                        }
                    },
                    xAxis: {
                        categories: this.monthCartListInfo,
                        title: {
                            text: '<b >Date</b>'
                        }
                    },
                    yAxis: {
                        min: null,
                        title: {
                            text: '<b >Power</b>',
                            align: 'middle'
                        },
                        labels: {
                            overflow: 'justify'
                        }
                    },
                    plotOptions: {
                        pie: {
                            allowPointSelect: true,
                            cursor: 'pointer',
                            dataLabels: {
                                enabled: false
                            },
                            showInLegend: true
                        }
                    },

                    series: [
                        {
                            name: 'Power Consumed',
                            data: this.monthCartListInfoPowerConsumed,
                            color: '#EF4323',
                            type: 'column'
                        },
                        {
                            name: 'Power Genrated',
                            data: this.monthCartListInfoPower,
                            color: '#2CD391',
                            type: 'column'
                        }
                    ]
                };
            });


    }

    lifeTimeChartInfo() {
        this.graphLoader = true;
        this.monthCartListInfo = [];
        this.monthCartListInfoPower = [];
        this.monthCartListInfoPowerConsumed = [];
        this._utilityService
            .getliftTimeChart(this.getStationCode)
            .subscribe((res) => {
                if (res) {
                    this.lifetTimeWisePG = true
                    this.monthWisePG = false;
                    this.yearWisePG = false;
                    this.dayWisePG = false;
                    var monthCartList = [];
                    monthCartList = res.data;

                    // monthCartList.forEach((e) => {
                    //     this.monthCartListInfo.push(
                    //         e.collectTime.toString().split('T')[0]
                    //     );
                    //     this.monthCartListInfoPower.push(e.power);
                    // });
                    monthCartList.forEach((e) => {
                        const newdate = new Date(Number(e.timestamp) * 1000);
                        const datetime = this.datePipe.transform(newdate, 'yyyy-MM-dd'); //'dd/MM/yyyy'
                        this.monthCartListInfo.push(
                            //e.collectTime.toString().split('T')[0]
                            datetime
                        );
                        //debugger;
                        this.monthCartListInfoPower.push(e.powerGenerated);
                        this.monthCartListInfoPowerConsumed.push(e.powerConsumed);
                        // this.monthCartListInfo.push(
                        //     e.collectTime.toString().split('T')[0]
                        // );
                        // this.monthCartListInfoPower.push(e.power);

                    });
                }

                this.barChart = {
                    chart: { backgroundColor: 'transparent' },   // ADD
                    title: {
                        text: '',

                        style: {
                            color: 'green',
                            align: 'left'
                        }
                    },
                    xAxis: {
                        categories: this.monthCartListInfo,
                        title: {
                            text: '<b >Date</b>'
                        }
                    },
                    yAxis: {
                        min: null,
                        title: {
                            text: '<b >Power</b>',
                            align: 'middle'
                        },
                        labels: {
                            overflow: 'justify'
                        }
                    },
                    plotOptions: {
                        pie: {
                            allowPointSelect: true,
                            cursor: 'pointer',
                            dataLabels: {
                                enabled: false
                            },
                            showInLegend: true
                        }
                    },

                    series: [
                        {
                            name: 'Power Consumed',
                            data: this.monthCartListInfoPowerConsumed,
                            color: '#EF4323',
                            type: 'column'
                        },
                        {
                            name: 'Power Genrated',
                            data: this.monthCartListInfoPower,
                            color: '#2CD391',
                            type: 'column'
                        }
                    ]
                };
            });

        this.graphLoader = false;

    }

    showData(strin: string, selectedNumber: number, devId: number) {
        this.loader = true;
        this.selectedNumber = selectedNumber;
        this._utilityService.sendDeviD(this.selectedNumber);
        this._utilityService.sendDeviD2(this.getStationCode);
        if (strin === 'graphicalView') {
            this.vardata = false;
            this.graphicalView = true;
            this.setGraphicalView(devId, this.dtEmiEnv);
        }
        if (strin === 'data') {
            this.graphicalView = false;
            this.vardata = true;
        }
        this.loader = false;
    }

    // old pv graph

    // showDataWithDate(strin: string, selectedNumber: number, devId: number, e) {
    //     this.loader = true;
    //     this.selectedNumber = selectedNumber;
    //     this._utilityService.sendDeviD(this.selectedNumber);
    //     this._utilityService.sendDeviD2(this.getStationCode);
    //     if (strin === 'graphicalView') {
    //         this.vardata = false;
    //         this.graphicalView = true;

    //         this.setGraphicalView(devId, e);
    //     }
    //     if (strin === 'data') {
    //         this.graphicalView = false;
    //         this.vardata = true;
    //     }

    //     this.loader = false;
    // }

    // processGraphTime(arrTime: any) {
    //     this.lineChartLabels.length = 0;
    //     arrTime.forEach((e) => {
    //         const date = new Date(Number(e) * 1000);
    //         const time = this.datePipe.transform(date, 'hh:mm a');
    //         this.lineChartLabels.push(
    //             time
    //         );
    //     });

    //     //lineChartLabels.push()
    // }

    // etGraphicalView(devId: number, dt: Date) {
    //     this.loader = true;
    //     this._utilityService.newPvGraphsList(devId, dt).subscribe((res) => {
    //         if (res) {

    //             this.pvGraphRes = res;
    //             this.pvGraphKey = this.pvGraphRes[0].keys;
    //             this.processGraphTime(this.pvGraphRes[0].time)
    //             this.SetGraphData();
    //             this.loader = false;
    //         }
    //     })
    // }

    //  onCheckboxChange(): void {
    //     ////debugger;   
    //     // Handle checkbox change event        
    //     this.SetGraphData();
    //     // You can perform additional actions based on the checkbox state here
    // }

    // isCheckBoxDisabled(item): boolean {
    //     if (item.status == false) {
    //         const filteredObjects = this.pvGraphKey.filter(obj => obj.status === 1 || obj.status === true);
    //         if (filteredObjects.length < 5) {
    //             return false;
    //         }
    //         return true;
    //     }
    //     else
    //         return false;
    // }

    // /old pv graph

    // new pv graph-
    showDataWithDate(strin: string, selectedNumber: number, devId: number, e) {
        if (!e) {
            this.toaster.warning('Date is required.');
            return;
        }
        this.loader = true;
        this.selectedNumber = selectedNumber;
        this._utilityService.sendDeviD(this.selectedNumber);
        this._utilityService.sendDeviD2(this.getStationCode);
        const formattedDate = formatDate(e, 'yyyy-MM-dd', 'en-US');
        if (strin === 'graphicalView') {
            this.vardata = false;
            this.graphicalView = true;

            this.setGraphicalView(devId, formattedDate);
        }
        if (strin === 'data') {
            this.graphicalView = false;
            this.vardata = true;
        }

        this.loader = false;
    }

    processGraphTime(arrTime: any) {
        this.lineChartLabels.length = 0;
        arrTime.forEach((e) => {
            const date = new Date(Number(e) * 1000);
            const time = this.datePipe.transform(date, 'hh:mm a');
            this.lineChartLabels.push(time);
        });
    }
    updateChartCategories() {
        if (this.pvMultilineChartOptions.xAxis && Array.isArray(this.pvMultilineChartOptions.xAxis)) {
            (this.pvMultilineChartOptions.xAxis[0] as any).categories = [...this.lineChartLabels];
        }
        // Trigger update after categories change
        // console.log('📅 Setting X-Axis categories:', this.lineChartLabels);
        // console.log('📈 Chart before category update:', this.pvMultilineChartOptions);
        // this.updateChart();

    }
    // Helper to count selected Y-axis types
    getSelectedYAxisCount(): number {
        let count = 0;

        if (this.selectedVoltages && this.selectedVoltages.length) count++;
        if (this.selectedCurrents && this.selectedCurrents.length) count++;
        if (this.selectedPowers && this.selectedPowers.length) count++;
        if (this.selectedEnergy && this.selectedEnergy.length) count++;
        if (this.selectedPercentage && this.selectedPercentage.length) count++;
        if (this.selectedTemperature && this.selectedTemperature.length) count++;
        if (this.selectedFrequency && this.selectedFrequency.length) count++;

        return count;
    }
    private previousSelections = {
        voltages: [],
        currents: [],
        powers: [],
        energy: [],
        percentage: [],
        temperature: [],
        frequency: []
    };
    onDropdownSelectionChange() {
        const yAxisTypeCount = this.getSelectedYAxisCount();

        if (yAxisTypeCount > 3) {
            this.toaster.warning('You can select a maximum of 3 filter types for Y-axis.');

            // Revert to previous selections
            this.selectedVoltages = [...this.previousSelections.voltages];
            this.selectedCurrents = [...this.previousSelections.currents];
            this.selectedPowers = [...this.previousSelections.powers];
            this.selectedEnergy = [...this.previousSelections.energy];
            this.selectedPercentage = [...this.previousSelections.percentage];
            this.selectedTemperature = [...this.previousSelections.temperature];
            this.selectedFrequency = [...this.previousSelections.frequency];

            return;
        }

        // Store current selections as valid
        this.previousSelections = {
            voltages: [...this.selectedVoltages],
            currents: [...this.selectedCurrents],
            powers: [...this.selectedPowers],
            energy: [...this.selectedEnergy],
            percentage: [...this.selectedPercentage],
            temperature: [...this.selectedTemperature],
            frequency: [...this.selectedFrequency]
        };

        this.performChartUpdate();
    }

    // Method to handle dropdown selections
    // onDropdownSelectionChange() {
    //     // const totalSelected =
    //     //     this.selectedVoltages.length +
    //     //     this.selectedCurrents.length +
    //     //     this.selectedPowers.length +
    //     //     this.selectedEnergy.length +
    //     //     this.selectedPercentage.length +
    //     //     this.selectedTemperature.length +
    //     //     this.selectedFrequency.length;

    //     // if (totalSelected > 3) {
    //     //     this.toaster.warning('You can select a maximum of 3 filters for Y-axis.');
    //     //     return;
    //     // }
    //     const yAxisTypeCount = this.getSelectedYAxisCount();

    //     if (yAxisTypeCount > 3) {
    //         this.toaster.warning('You can select a maximum of 3 filter types for Y-axis.');
    //         return;
    //     }
    //     this.performChartUpdate();
    // }
    performChartUpdate() {
        // Move the entire update logic outside change detection cycle
        setTimeout(() => {
            this.updateChartSeries();
        }, 0);
    }
    clearChartSeries() {
        if (!this.pvMultilineChartOptions) {
            console.warn('Chart options not initialized yet');
            return;
        }

        // Clear series
        this.pvMultilineChartOptions.series = [];

        // Clear x-axis categories if array exists
        if (Array.isArray(this.pvMultilineChartOptions.xAxis)) {
            (this.pvMultilineChartOptions.xAxis[0] as any).categories = [];
        }

        this.updateChart(); // Trigger re-render
    }
    clearAllDropdownSelections() {
        this.selectedVoltages = [];
        this.selectedCurrents = [];
        this.selectedPowers = [];
        this.selectedEnergy = [];
        this.selectedPercentage = [];
        this.selectedTemperature = [];
        this.selectedFrequency = [];

        // Also reset previousSelections to keep it in sync
        this.previousSelections = {
            voltages: [],
            currents: [],
            powers: [],
            energy: [],
            percentage: [],
            temperature: [],
            frequency: []
        };
    }
    clearPVChart() {
        this.clearChartSeries()
        this.clearAllDropdownSelections()
    }

    // Drop the selected filters and the chart built from them so the next
    // graphical view is created from scratch at full width.
    resetPvGraphFilters() {
        this.clearAllDropdownSelections();
        this.pvMultilineChartOptions = null;
        this.pvCharts = [];
    }

    // highcharts-angular doesn't expose the chart on the component, so grab it
    // from chartInstance. A chart created while its slide was still sliding in
    // measures a stale width (Highcharts falls back to ~600px), so reflow it
    // once the container has settled.
    onPvChartInstance(chart: Highcharts.Chart) {
        this.pvCharts = [...this.pvCharts.filter((c) => c !== chart && c.container?.isConnected), chart];
        [0, 150, 400].forEach((delay) => setTimeout(() => this.reflowPvCharts(), delay));
    }

    private reflowPvCharts() {
        this.pvCharts = this.pvCharts.filter((c) => c.container?.isConnected);
        this.pvCharts.forEach((c) => c.reflow());
    }


    // updateChartSeries() {
    //     const newSeries: Highcharts.SeriesOptionsType[] = [];
    //     let seriesIndex = 0;
    //     // const safeData = (arr: any[]) => arr?.map(v => v ?? 0) ?? [];
    //     const safeData = (arr?: (number | null)[]) =>
    //         (arr ?? []).map(v => (v === 0 || v == null ? null : v));


    //     // Build dynamic axes first
    //     const dynamicYAxes = this.createDynamicYAxes();

    //     // Map each data type to its dynamic index
    //     const axisMap: Record<string, number> = {};
    //     let axisCounter = 0;

    //     const mapAxis = (keys: string[], type: string) => {
    //         if (keys.some(key => this.pvGraphRes?.[0]?.[key])) {
    //             axisMap[type] = axisCounter++;
    //         }
    //     };

    //     mapAxis(this.selectedVoltages, 'voltage');
    //     mapAxis(this.selectedCurrents, 'current');
    //     mapAxis(this.selectedPowers, 'power');
    //     mapAxis(this.selectedEnergy, 'energy');
    //     mapAxis(this.selectedPercentage, 'percentage');
    //     mapAxis(this.selectedTemperature, 'temperature');
    //     mapAxis(this.selectedFrequency, 'frequency');

    //     // Helper to add series with correct dynamic index
    //     const addSeries = (keys: string[], type: string, unit: string) => {
    //         if (axisMap[type] !== undefined) {
    //             keys.forEach(key => {
    //                 if (this.pvGraphRes?.[0]?.[key]) {
    //                     newSeries.push({
    //                         name: this.formatSeriesName(key),
    //                         type: 'line',
    //                         yAxis: axisMap[type], // <--- dynamic index
    //                         data: safeData(this.pvGraphRes[0][key]),
    //                         color: this.generateSeriesColor(type, seriesIndex),
    //                         tooltip: { valueSuffix: ` ${unit}` },
    //                         turboThreshold: 0,

    //                     });
    //                     seriesIndex++;
    //                 }
    //                 console.log("xAxis categories:", this.lineChartLabels.length);
    //                 console.log("series data:", safeData(this.pvGraphRes[0][key]).length);

    //             });
    //         }
    //     };

    //     addSeries(this.selectedVoltages, 'voltage', 'V');
    //     addSeries(this.selectedCurrents, 'current', 'A');
    //     addSeries(this.selectedPowers, 'power', 'W');
    //     addSeries(this.selectedEnergy, 'energy', 'J');
    //     addSeries(this.selectedPercentage, 'percentage', '%');
    //     addSeries(this.selectedTemperature, 'temperature', '°C');
    //     addSeries(this.selectedFrequency, 'frequency', 'Hz');

    //     this.pvMultilineChartOptions = {
    //         ...this.pvMultilineChartOptions,
    //         xAxis: [{
    //             type: 'category',
    //             categories: [...this.lineChartLabels],
    //             crosshair: true
    //         }],
    //         yAxis: dynamicYAxes, // <--- use updated axes
    //         series: [...newSeries]
    //     };

    //     console.log('Updated Chart Options:', this.pvMultilineChartOptions);
    //     console.log('dynamicYAxes', dynamicYAxes);

    //     this.updateChart();
    // }

    generateSeriesColor(type: string, index: number): string {
        const baseColor = this.colorObj[type];
        // You can modify opacity or hue for multiple series of same type
        const opacity = Math.max(0.7, 1 - (index * 0.1));
        return baseColor + Math.round(opacity * 255).toString(16).padStart(2, '0');
    }

    formatSeriesName(key: string): string {
        // Convert "PV1Voltage" to "PV1 Voltage"
        return key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());
    }

    //     updateChart() {
    //     // Force a complete chart refresh
    //     setTimeout(() => {
    //         this.updateFlag = !this.updateFlag; // Toggle the flag instead of just setting true
    //         this.cdr.detectChanges(); // Ensure change detection runs
    //     }, 50); // Slightly longer timeout to ensure DOM is ready
    // }
    // updateChart() {
    //     setTimeout(() => {
    //         // Create a completely new reference to force Angular to detect changes
    //         this.pvMultilineChartOptions = { ...this.pvMultilineChartOptions };
    //         this.updateFlag = !this.updateFlag;
    //         this.pvMultiChart.chart.reflow();
    //         this.cdr.detectChanges();
    //         console.log(this.pvMultiChart.chart.container.offsetWidth);

    //     }, 100);
    // }
    // createDynamicYAxes(): Highcharts.YAxisOptions[] {
    //     const axes: Highcharts.YAxisOptions[] = [];

    //     const hasData = (data?: (number | null)[]) =>
    //         data?.some(v => v != null) ?? false;

    //     const addAxis = (keys: string[], config: Highcharts.YAxisOptions) => {
    //         const containsData = keys.some(key => hasData(this.pvGraphRes?.[0]?.[key]));
    //         if (containsData) {
    //             axes.push(config); // No min/max applied
    //         }
    //     };

    //     addAxis(this.selectedVoltages, {
    //         labels: { format: '{value}V', style: { color: this.colorObj.voltage } },
    //         title: { text: 'Voltage', style: { color: this.colorObj.voltage } },
    //         opposite: false,

    //     });

    //     addAxis(this.selectedCurrents, {
    //         gridLineWidth: 0,
    //         labels: { format: '{value}A', style: { color: this.colorObj.current } },
    //         title: { text: 'Current', style: { color: this.colorObj.current } },
    //         opposite: true,

    //     });

    //     addAxis(this.selectedPowers, {
    //         gridLineWidth: 0,
    //         labels: { format: '{value}W', style: { color: this.colorObj.power } },
    //         title: { text: 'Power', style: { color: this.colorObj.power } },
    //         opposite: true,

    //     });

    //     addAxis(this.selectedEnergy, {
    //         gridLineWidth: 0,
    //         labels: { format: '{value}J', style: { color: this.colorObj.energy } },
    //         title: { text: 'Energy', style: { color: this.colorObj.energy } },
    //         opposite: true,

    //     });

    //     addAxis(this.selectedPercentage, {
    //         gridLineWidth: 0,
    //         labels: { format: '{value}%', style: { color: this.colorObj.percentage } },
    //         title: { text: 'Percentage', style: { color: this.colorObj.percentage } },
    //         opposite: true,

    //     });

    //     addAxis(this.selectedTemperature, {
    //         gridLineWidth: 0,
    //         labels: { format: '{value}°C', style: { color: this.colorObj.temperature } },
    //         title: { text: 'Temperature', style: { color: this.colorObj.temperature } },
    //         opposite: true,

    //     });

    //     addAxis(this.selectedFrequency, {
    //         gridLineWidth: 0,
    //         labels: { format: '{value}Hz', style: { color: this.colorObj.frequency } },
    //         title: { text: 'Frequency', style: { color: this.colorObj.frequency } },
    //         opposite: true,

    //     });

    //     // return yAxes;
    //     return axes;
    // }
    capitalize(text: any): string {
        return text.charAt(0).toUpperCase() + text.slice(1);
    }
    formatSmartValue(value: number, unit: string): string {
        // Special handling for Watts - values are already in KW
        if (unit === 'W') {
            if (value >= 1_000_000) return `${(value / 1_000_000).toFixed(1)}GW`;
            if (value >= 1_000) return `${(value / 1_000).toFixed(1)}MW`;
            return `${value}KW`; // Default is KW
        }

        // Standard formatting for other units
        if (value >= 1_000_000_000) return `${(value / 1_000_000_000).toFixed(1)}G${unit}`;
        if (value >= 1_000_000) return `${(value / 1_000_000).toFixed(1)}M${unit}`;
        if (value >= 1_000) return `${(value / 1_000).toFixed(1)}K${unit}`;
        return `${value}${unit}`;
    }

    createDynamicYAxes(): Highcharts.YAxisOptions[] {
        const axes: Highcharts.YAxisOptions[] = [];
        let axisCount = 0;

        const hasData = (data?: (number | null)[]) =>
            data?.some(v => v != null) ?? false;

        // Helper function to format values with K/M/G
        const formatWithUnit = (value: number, unit: string): string => {
            // Special handling for Watts - values are already in KW
            if (unit === 'W') {
                if (value >= 1_000_000) return `${(value / 1_000_000).toFixed(1)}GW`;
                if (value >= 1_000) return `${(value / 1_000).toFixed(1)}MW`;
                return `${value}KW`; // Default is KW
            }

            // Standard formatting for other units
            if (value >= 1_000_000_000) return `${(value / 1_000_000_000).toFixed(1)}G${unit}`;
            if (value >= 1_000_000) return `${(value / 1_000_000).toFixed(1)}M${unit}`;
            if (value >= 1_000) return `${(value / 1_000).toFixed(1)}K${unit}`;
            return `${value}${unit}`;
        };

        const addAxis = (keys: string[], type: keyof typeof this.colorObj, unit: string) => {
            if (axisCount >= 3) return; // Limit to max 3 y-axes

            const containsData = keys.some(key => hasData(this.pvGraphRes?.[0]?.[key]));
            if (containsData) {
                axes.push({
                    gridLineWidth: axisCount === 0 ? 1 : 0, // Only first axis shows grid
                    labels: {
                        style: { color: this.colorObj[type] },
                        formatter: function () {
                            // Use arrow function to maintain context or regular function with proper this binding
                            const val = this.value as number;
                            return formatWithUnit(val, unit);
                        }
                    },
                    title: {
                        text: this.capitalize(type),
                        style: {
                            color: this.colorObj[type],
                            fontWeight: 'bold'
                        }
                    },
                    opposite: axisCount !== 0, // First axis on left, others on right
                });
                axisCount++;
            }
        };

        // Add axes for each metric type
        addAxis(this.selectedVoltages, 'voltage', 'V');
        addAxis(this.selectedCurrents, 'current', 'A');
        addAxis(this.selectedPowers, 'power', 'W');
        addAxis(this.selectedEnergy, 'energy', 'J');
        addAxis(this.selectedPercentage, 'percentage', '%');
        addAxis(this.selectedTemperature, 'temperature', '°C');
        addAxis(this.selectedFrequency, 'frequency', 'Hz');

        return axes;
    }

    // createDynamicYAxes(): Highcharts.YAxisOptions[] {
    //     const axes: Highcharts.YAxisOptions[] = [];
    //     let axisCount = 0;

    //     const hasData = (data?: (number | null)[]) =>
    //         data?.some(v => v != null) ?? false;

    //     const addAxis = (keys: string[], type: keyof typeof this.colorObj, unit: string) => {
    //         if (axisCount >= 3) return; // Limit to max 3 y-axes

    //         const containsData = keys.some(key => hasData(this.pvGraphRes?.[0]?.[key]));
    //         if (containsData) {
    //             axes.push({
    //                 gridLineWidth: 0,
    //                 labels: { format: `{value}${unit}`, style: { color: this.colorObj[type] } },
    //                 title: { text: this.capitalize(type), style: { color: this.colorObj[type] } },
    //                 opposite: axisCount !== 0, // First axis on left, others on right
    //             });
    //             axisCount++;
    //         }
    //     };

    //     addAxis(this.selectedVoltages, 'voltage', 'V');
    //     addAxis(this.selectedCurrents, 'current', 'A');
    //     addAxis(this.selectedPowers, 'power', 'W');
    //     addAxis(this.selectedEnergy, 'energy', 'J');
    //     addAxis(this.selectedPercentage, 'percentage', '%');
    //     addAxis(this.selectedTemperature, 'temperature', '°C');
    //     addAxis(this.selectedFrequency, 'frequency', 'Hz');

    //     return axes;
    // }

    updateChartSeries() {
        const newSeries: Highcharts.SeriesOptionsType[] = [];
        let seriesIndex = 0;

        const safeData = (arr?: (number | null)[]) =>
            (arr ?? []).map(v => (v === 0 || v == null ? null : v));

        // Build dynamic axes
        const dynamicYAxes = this.createDynamicYAxes();

        // Map each data type to its dynamic index
        const axisMap: Record<string, number> = {};
        let axisCounter = 0;

        const mapAxis = (keys: string[], type: string) => {
            if (keys.some(key => this.pvGraphRes?.[0]?.[key])) {
                axisMap[type] = axisCounter++;
            }
        };

        mapAxis(this.selectedVoltages, 'voltage');
        mapAxis(this.selectedCurrents, 'current');
        mapAxis(this.selectedPowers, 'power');
        mapAxis(this.selectedEnergy, 'energy');
        mapAxis(this.selectedPercentage, 'percentage');
        mapAxis(this.selectedTemperature, 'temperature');
        mapAxis(this.selectedFrequency, 'frequency');

        // Helper to format tooltip values
        const formatTooltipValue = (value: number, unit: string): string => {
            // Special handling for Watts - values are already in KW
            if (unit === 'W') {
                if (value >= 1_000_000) return `${(value / 1_000_000).toFixed(2)} GW`;
                if (value >= 1_000) return `${(value / 1_000).toFixed(2)} MW`;
                return `${value.toFixed(2)} KW`; // Default is KW
            }

            if (value >= 1_000_000_000) return `${(value / 1_000_000_000).toFixed(2)} G${unit}`;
            if (value >= 1_000_000) return `${(value / 1_000_000).toFixed(2)} M${unit}`;
            if (value >= 1_000) return `${(value / 1_000).toFixed(2)} K${unit}`;
            return `${value} ${unit}`;
        };

        // Add series
        const addSeries = (keys: string[], type: string, unit: string) => {
            if (axisMap[type] !== undefined) {
                keys.forEach(key => {
                    if (this.pvGraphRes?.[0]?.[key]) {
                        newSeries.push({
                            name: this.formatSeriesName(key),
                            type: 'line',
                            yAxis: axisMap[type],
                            data: safeData(this.pvGraphRes[0][key]),
                            color: this.generateSeriesColor(type, seriesIndex),
                            tooltip: {
                                pointFormatter: function () {
                                    // Format tooltip value with K/M/G
                                    const formattedValue = formatTooltipValue(this.y || 0, unit);
                                    return `<span style="color:${this.color}">●</span> ${this.series.name}: <b>${formattedValue}</b><br/>`;
                                }
                            },
                            turboThreshold: 0,
                        });
                        seriesIndex++;
                    }
                });
            }
        };

        addSeries(this.selectedVoltages, 'voltage', 'V');
        addSeries(this.selectedCurrents, 'current', 'A');
        addSeries(this.selectedPowers, 'power', 'W');
        addSeries(this.selectedEnergy, 'energy', 'J');
        addSeries(this.selectedPercentage, 'percentage', '%');
        addSeries(this.selectedTemperature, 'temperature', '°C');
        addSeries(this.selectedFrequency, 'frequency', 'Hz');

        // CRITICAL: Create completely new chart options object
        this.pvMultilineChartOptions = {
            chart: {
                zooming: { type: 'xy' },
                type: 'line',
                backgroundColor: 'transparent',
                height: 400,
                width: null,
                marginBottom: 80,
            },
            title: {
                text: ''
            },
            credits: {
                enabled: false
            },
            xAxis: {
                type: 'category',
                categories: [...this.lineChartLabels],
                crosshair: true
            },
            yAxis: dynamicYAxes,
            tooltip: {
                shared: true
            },
            legend: {
                layout: 'horizontal',
                align: 'center',
                verticalAlign: 'bottom',
                y: 40,
                symbolRadius: 16,
            },
            plotOptions: {
                series: {
                    connectNulls: true,
                    marker: {
                        enabled: false, // Show marker in legend
                        symbol: 'circle' // Ensure the marker is circular
                    }
                }
            },
            series: newSeries,
            responsive: {
                rules: [{
                    condition: {
                        maxWidth: 500
                    },
                    chartOptions: {
                        legend: {
                            layout: 'horizontal',
                            align: 'center',
                            verticalAlign: 'bottom'
                        }
                    }
                }]
            }
        };

        // console.log('Updated Chart Options:', this.pvMultilineChartOptions);
        // console.log('dynamicYAxes', dynamicYAxes);
        // console.log('series data length:', newSeries.length);
        // console.log('categories length:', this.lineChartLabels.length);

        // Force update
        this.updateChart();
    }
    updateChart() {
        this.pvMultilineChartOptions = { ...this.pvMultilineChartOptions };
        this.updateFlag = !this.updateFlag;

        setTimeout(() => {
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    // if (this.pvMultiChart?.chart) {
                    //     this.pvMultiChart.chart.reflow();
                    //     // Now get updated container dimensions after reflow
                    //     const containerWidth = this.pvMultiChart.chart.container.offsetWidth;
                    //     const containerHeight = this.pvMultiChart.chart.container.offsetHeight;

                    //     this.pvMultiChart.chart.setSize(containerWidth, containerHeight, false);

                    //     console.log('Reflowed width:', containerWidth);
                    // }
                    this.reflowPvCharts();

                });
            });
        }, 0);
    }


    // Enhanced SetGraphData method
    SetGraphData() {
        if (!this.hasFiltersSelected()) {
            console.warn('No filters selected, skipping chart update.');
            this.pvMultilineChartOptions = null; // Optional: reset chart
            return;
        }

        if (!this.pvGraphRes || !this.pvGraphRes[0]) {
            console.error('No graph data available');
            return;
        }

        // console.log('Setting graph data with:', {
        //     categories: this.lineChartLabels?.length,
        //     selectedVoltages: this.selectedVoltages?.length,
        //     selectedCurrents: this.selectedCurrents?.length,
        //     graphData: Object.keys(this.pvGraphRes[0])
        // });

        this.updateChartSeries();
    }

    // SetGraphData() {
    //     this.updateChartSeries();
    // }
    // Make sure this is called after API data is loaded
    setGraphicalView(devId: number, dt: string | Date) {
        this.loader = true;
        this._utilityService.newPvGraphsList(devId, dt).subscribe((res) => {
            if (res) {
                this.pvGraphRes = res;
                this.pvGraphKey = this.pvGraphRes[0].keys;
                this.mapPvDropDowns(this.pvGraphRes[0].dropdown_keys || {});
                this.processGraphTime(this.pvGraphRes[0].time);

                // Initialize chart first
                // this.multiPvGraphInit();
                // Then update categories
                this.updateChartCategories();

                // Finally set graph data (which calls updateChartSeries)
                this.SetGraphData();

                this.loader = false;
            }
        });
    }
    hasFiltersSelected(): boolean {
        return (
            (this.selectedVoltages?.length ?? 0) > 0 ||
            (this.selectedCurrents?.length ?? 0) > 0 ||
            (this.selectedPowers?.length ?? 0) > 0 ||
            (this.selectedEnergy?.length ?? 0) > 0 ||
            (this.selectedPercentage?.length ?? 0) > 0 ||
            (this.selectedTemperature?.length ?? 0) > 0 ||
            (this.selectedFrequency?.length ?? 0) > 0
        );
    }

    // setGraphicalView(devId: number, dt: Date) {
    //     this.loader = true;
    //     this._utilityService.newPvGraphsList(devId, dt).subscribe((res) => {
    //         if (res) {
    //             this.pvGraphRes = res;
    //             this.pvGraphKey = this.pvGraphRes[0].keys;
    //             this.mapPvDropDowns(this.pvGraphRes[0].dropdown_keys || {})
    //             this.processGraphTime(this.pvGraphRes[0].time)
    //             this.SetGraphData();
    //             this.loader = false;
    //         }
    //     })
    // }
    mapPvDropDowns(k: any) {
        this.pvVoltages = k.voltages || [];
        this.pvCurrents = k.currents || [];
        this.pvEnergy = k.energy || [];
        this.pvPowers = k.powers || [];
        this.pvTemperature = k.temperature || [];
        this.pvPercentage = k.percentage || [];
        this.pvFrequency = k.frequency || [];
    }
    // /new pv graph

    enertyFlow(st: string) {
        const previousTab = this.getCurrentTab();
        if (st === 'energyFlow') {
            this.ppf = true;
            this.invert = false;
            this.pv = false;
            this.roi = false;
            this.eme = false;
            this.wapda = false;
            this.devices = false;
            this.alarms = false;
        }
        if (st === 'inverter') {
            this.ppf = false;
            this.invert = true;
            this.pv = false;
            this.eme = false;
            this.roi = false;
            this.wapda = false;
            this.devices = false;
            this.alarms = false;
        }
        if (st === 'pv') {
            this.ppf = false;
            this.invert = false;
            this.pv = true;
            this.eme = false;
            this.roi = false;
            this.EmiGraph(this.dtEnv);
            this.wapda = false;
            this.devices = false;
            this.alarms = false;
        }
        if (st === 'emi') {
            this.ppf = false;
            this.invert = false;
            this.pv = false;
            this.eme = true;
            this.roi = false;
            this.wapda = false;
            this.devices = false;
            this.alarms = false;
        }
        if (st === 'roi') {
            this.ppf = false;
            this.invert = false;
            this.pv = false;
            this.eme = false;
            this.roi = true;
            this.wapda = false;
            this.devices = false;
            this.alarms = false;
        }
        if (st === 'wapda') {
            this.ppf = false;
            this.invert = false;
            this.pv = false;
            this.eme = false;
            this.roi = false;
            this.wapda = true;
            this.devices = false;
            this.alarms = false;
        }
        if (st === 'devices') {
            this.ppf = false;
            this.invert = false;
            this.pv = false;
            this.eme = false;
            this.roi = false;
            this.wapda = false;
            this.devices = true;
            this.alarms = false;
        }
        if (st === 'alarms') {
            this.ppf = false;
            this.invert = false;
            this.pv = false;
            this.eme = false;
            this.roi = false;
            this.wapda = false;
            this.devices = false;
            this.alarms = true;
        }
        // Clear inverter chart if switching away from it
        if (previousTab === 'inverter' && st !== 'inverter') {
            this.graphicalView = false;
            this.vardata = true;
            // Reset chart before reflow
            this.clearPVChart();
        }

    }
    getCurrentTab(): string {
        if (this.invert) return 'inverter';
        if (this.ppf) return 'energyFlow';
        if (this.pv) return 'pv';
        if (this.eme) return 'emi';
        if (this.roi) return 'roi';
        if (this.wapda) return 'wapda';
        if (this.devices) return 'devices';
        if (this.alarms) return 'alarms';
        return '';
    }

    openUpdateCostModal(ticketDetail: any) {
        this.originalCost = this.plantDetail.cost;
        this.modalService.open(ticketDetail, { windowClass: "complainModelClass" });
    }
    openPredictionModal(predictionModal: any) {
        this.originalCost = this.plantDetail.cost;
        this.modalService.open(predictionModal, { windowClass: "complainModelClass" });
        if (this.roiParameters) {
            setTimeout(() => {
                this.predictionParameterForm.patchValue({
                    cost: this.originalCost ? formatNumber(this.originalCost, 'en-US', '2.0-0') : this.originalCost,
                    baseProduction: this.roiParameters['base'],
                    nextYearProduction: this.roiParameters['next_year_production'],
                    tariffRate: this.roiParameters['tariff_rate'],
                    dipPercentage: this.roiParameters['dip_percentage']
                });
            }, 100);
        }
        else {
            setTimeout(() => {
                this.predictionParameterForm.patchValue({
                    cost: this.originalCost ? formatNumber(this.originalCost, 'en-US', '2.0-0') : this.originalCost,
                })
            }, 100);
        }
    }

    handleCancel(dismiss: Function) {
        this.plantDetail.cost = this.originalCost;
        dismiss('Cancel click');
    }

    updateInstallationCost() {

        this.loader = true;
        this._utilityService.updateInstallationCost(this.plantDetail.stationCode, this.plantDetail.cost).subscribe((res) => {
            if (res && res.status === 200) {
                this.loader = false;
                this.plantDetail.costFormatted = this.convertToThousandsMillions(res.data.cost)
                Swal.fire({
                    icon: 'success',
                    title: 'Cost Updated',
                    text: 'ROI Graph needs to be processed again.',
                    showConfirmButton: false,
                    timer: 1600
                });
                setTimeout(() => {
                    this.getYearlyRoiGraph();
                }, 2000);
            }
            else {
                this.loader = false;
                this.toaster.error(res.message)
                this.monthlyRoi = true
                this.yearlyRoi = false
                this.plantDetail.costFormatted = this.convertToThousandsMillions(this.plantDetail.cost)
            }
        })
    }

    onPredictionParamters() {
        if (this.predictionParameterForm.valid) {
            const payload = {
                stationCode: this.plantDetail.stationCode,
                cost: this.predictionParameterForm.value.cost ? parseFloat(this.predictionParameterForm.value.cost.replace(/,/g, '')) : null,
                // date: this.predictionParameterForm.value.date ? this.datePipe.transform(this.predictionParameterForm.value.date, 'yyyy-MM-dd') : null,
                baseProduction: parseInt(this.predictionParameterForm.value.baseProduction),
                nextYearProduction: parseInt(this.predictionParameterForm.value.nextYearProduction),
                tariffRate: parseFloat(this.predictionParameterForm.value.tariffRate),
                dipPercentage: parseFloat((this.predictionParameterForm.value.dipPercentage / 100).toFixed(3)),
            }
            this.loader = true;
            this._utilityService.predictedRoiApi(payload).subscribe((res) => {
                if (res && res.status === 201) {
                    this.loader = false;
                    this.predictedRoiData = res.data
                    Swal.fire({
                        icon: 'success',
                        title: res.message,
                        showConfirmButton: false,
                        timer: 1600
                    });
                    setTimeout(() => {
                        this.getYearlyRoiGraph();
                    }, 2000);

                }
                else {
                    this.loader = false;
                    this.predictionParameterForm.reset()
                    this.toaster.error(res.message)
                    this.monthlyRoi = true
                    this.yearlyRoi = false
                }
            })
        }
        else {
            this.toaster.error('Please add Valid Form Data')
            this.predictionParameterForm.reset()
        }
    }

    reCalculateRoi() {

        this.loader = true;
        this._utilityService.reCalculateRoi(this.plantDetail.stationCode).subscribe((res) => {
            if (res && res.status === 200) {
                this.loader = false;
                setTimeout(() => {
                    this.getMonthlyRoiGraph();
                }, 1500);
            }
            else {
                this.loader = false;
                this.toaster.error(res.message)
                this.monthlyRoi = true
                this.yearlyRoi = false
            }
        })
    }

    toggleDisabled() {
        const car: any = this.cars[1];
        car.disabled = !car.disabled;
    }
    pvlist(strin: string, selectedNumber: number) {
        this.loader = true;
        this.selectedNumber = selectedNumber;
        this._utilityService.sendDeviD(this.selectedNumber);
        this._utilityService.sendDeviD2(this.getStationCode);
        if (strin === 'graphicalView') {
            this.vardata = false;
            this.graphicalView = true;
        }
        if (strin === 'data') {
            this.graphicalView = false;
            this.vardata = true;
        }
        this.loader = false;
    }
    selectInverterDetail() {
        this._utilityService.inverterPrimeData(this.getStationCode).subscribe((res) => {
            if (res) {
                this.inverterDetail = res.data;
                console.log(res.data)
                this.inverterDetail = res.data.map((item, index) => {
                    item.serialNumber = index + 1;

                    return item;
                });
            }
        });
    }
    prev() {
        if (this.currentIndex > 0) {
            this.currentIndex--;
        }
    }

    next() {
        if (this.currentIndex < this.inverterDetail.length - 1) {
            this.currentIndex++;
        }
    }
    pvDataList() {
        this._utilityService.pvgetData(this.getStationCode).subscribe((res) => {
            if (res) {
                this.pvList = res.data;
            }
        });
    }
    addSlide() {
        this.slides.push({ img: "http://placehold.it/350x150/777777" })
    }

    removeSlide() {
        this.slides.length = this.slides.length - 1;
    }

    slickInit(e) {
        console.log('slick initialized');
    }

    breakpoint(e) {
    }

    afterChange(e) {
        if (this.currentSlide === e.currentSlide) {
            return;
        }
        // Always track the visible slide (also while on Data View), otherwise
        // the chart reflow below targets the wrong slide's chart later on.
        this.currentSlide = e.currentSlide;

        // Every inverter has its own graph, so start each one from a clean
        // Data View with no filters carried over from the previous slide.
        this.loader = true;
        this.graphicalView = false;
        this.vardata = true;
        this.resetPvGraphFilters();
        setTimeout(() => {
            this.loader = false;
        }, 100);
    }
    setEvent(event: number) {
        console.log(event);
    }
    afterChangeValue(e) {
        this._utilityService.sendDeviD(this.selectedNumber);
    }

    beforeChange(e) {
        console.log('beforeChange');
    }
}
